<template>
<div class="flex-fill fill flex column" style="overflow-x: hidden">
<div v-if="local">

    <!-- Profile -->
    <div class="section mb20">
        <div class="flex align-center mb20">
            <div class="flex-fill flex">
                <img v-if="local.logotype" class="avatar round mr10 unshrink" :src="img(`logos/${local.logotype}`)" width="45" height="45" />
                <div>
                    <div class="f18">{{local.name}}</div>
                    <div v-if="local.slug" class="secondary-text" :title="`Nombre que se usa para iniciar sesión en ${local.name}`">Login: {{local.slug.replace(/-/g, ' ')}}</div>
                    <div v-if="franchise" class="secondary-text">{{desktop ? 'Sub Local de la franquicia' : 'Franquicia: '}} {{ franchise.name }}</div>
                </div>
            </div>
            <button class="secondary" @click="modalProfile=Util.Copy(local)">Editar</button>
        </div>

        <div>
            <div class="bold">Dirección</div>
            <div class="flex column" v-if="local.address">
                <div>{{local.address}}</div>
                <div class="secondary-text">{{local.latitude}}, {{local.longitude}}</div>
            </div>
            <div class="secondary-text" v-else>Sin dirección</div>
        </div>

        <div class="mt15" v-if="local.phone">
            <div class="bold">Teléfono</div>
            <div>{{local.phone}}</div>
        </div>

        <div class="mt15" v-if="local.instagram">
            <div class="bold">Instagram</div>
            <div>{{local.instagram}}</div>
        </div>

        <div class="mt15" v-if="local.public_email">
            <div class="bold">Email Público</div>
            <div>{{local.public_email}}</div>
        </div>

        <div class="mt15" v-if="local.email">
            <div class="bold">Email Administrativo</div>
            <div>{{local.email}}</div>
        </div>

        <div class="mt15 flex align-center" v-if="local.type == 'LOCAL'" >
            <div class="flex-fill">
                <div class="bold">Llave (Influye Service)</div>
                <div v-show="desktop">{{local.service_key}}</div>
            </div>
            <button class="secondary" @click="Util.Clipboard(local.service_key)">Copiar</button>
        </div>

        <div class="mt15 flex align-center" v-if="local.type == 'LOCAL' && facturacion">
            <div class="flex-fill">
                <div class="bold">Datos de Facturación</div>
                <div v-show="facturacion.rut">{{facturacion.name}} - {{ facturacion.rut }}</div>
            </div>
            <button class="secondary" @click="modalFacturacion=Util.Copy(facturacion)">Editar</button>
        </div>
    </div>

    <!-- Marcas -->
    <div>
        <div class="section mb20" v-for="(brand, index)  in brands" :key="index">
            <div class="flex align-center mb10">
                <div class="flex-fill flex">
                    <img v-if="brand.logotype" class="avatar round mr10 unshrink" :src="img(`logos/${brand.logotype}`)" width="45" height="45" />
                    <div>
                        <div class="f18">{{brand.name}}</div>
                    </div>
                </div>
                <button class="secondary" @click="modalProfile=Util.Copy(brand)">Editar</button>
                <div v-if="Auth.role == 'admin'" class="options icon-trash ml5" v-tooltip="'Eliminar marca'" @click.stop="Confirm({
                    text: 'Eliminar', 
                    class: 'error-color', 
                    title: '¿Eliminar marca?', 
                    function: () => DeleteBrand(brand)
                })"></div>
            </div>
            <div>
                <div class="bold">Dirección</div>
                <div class="flex column" v-if="brand.address">
                    <div>{{brand.address}}</div>
                    <!-- <div class="secondary-text">{{brand.latitude}}, {{brand.longitude}}</div> -->
                </div>
                <div class="secondary-text" v-else>Sin dirección</div>
            </div>

            <div class="mt15" v-if="brand.phone">
                <div class="bold">Teléfono</div>
                <div>{{brand.phone}}</div>
            </div>

            <div class="mt15" v-if="brand.instagram">
                <div class="bold">Instagram</div>
                <div>{{brand.instagram}}</div>
            </div>

            <div class="mt15" v-if="brand.public_email">
                <div class="bold">Email Público</div>
                <div>{{brand.public_email}}</div>
            </div>

            <div class="mt20" v-if="brand.integration_ue">
                <div class="separator mt20 mb20"></div>

                <div class="flex align-center mb10">
                    <div class="f18 flex flex-fill align-center">Uber Eats <badge v-if="brand.integration_ue.is_active" v-tooltip="'La integración con Uber Eats está activada'" pulse color="green" class="ml10" mini></badge></div>

                    <button
                        class="secondary"
                        @click="OpenModalUE(brand.integration_ue)"
                    >
                        Configurar
                    </button>
                </div>

                <div
                    v-if="!brand.integration_ue.is_active"
                    class="secondary-text mt10"
                >
                    La integración con Uber Eats no está activada
                </div>

                <div
                    v-else
                    class="secondary-text mt10"
                >
                    La integración con Uber Eats está activada
                </div>
                <div class="secondary-text" v-if="brand.integration_ue.is_active && brand.integration_ue.implement_menu">Sincronización de Menú activada</div>
                <div v-if="brand.integration_ue.is_active && brand.integration_ue.status" class="secondary-text">
                    Estado:
                    <span :class="[brand.integration_ue.status == 'ONLINE' ? 'cgreen' : 'cred', 'ml5']">
                        {{ brand.integration_ue.status == 'ONLINE' ? 'Abierto' : 'Cerrado' }}
                        <span v-if="brand.integration_ue.status == 'OFFLINE' && brand.integration_ue.is_offline_until">hasta {{ Util.Date(brand.integration_ue.is_offline_until, 'HH:mm') }}</span>
                    </span>
                </div>
            </div>

            <div class="mt20" v-if="brand.integration_pya">
                <div class="separator mt20 mb20"></div>

                <div class="flex align-center mb10">
                    <div class="f18 flex flex-fill align-center">PedidosYa <badge v-if="brand.integration_pya.is_active" v-tooltip="'La integración con PedidosYa está activada'" pulse color="green" class="ml10" mini></badge></div>

                    <button class="secondary" @click="modalPyaIntegration = Util.Copy(brand.integration_pya)">Configurar</button>
                </div>

                <div v-if="!brand.integration_pya.is_active" class="secondary-text mt10">La integración con PedidosYa no está activada</div>

                <div v-else class="secondary-text mt10">La integración con PedidosYa está activada</div>

                <div class="secondary-text" v-if="brand.integration_pya.is_active && brand.integration_pya.implement_menu">Sincronización de Menú activada</div>
                <div v-if="brand.integration_pya.is_active && brand.integration_pya.in_service" class="secondary-text">
                    Estado: <span :class="`${dictStatusPya[brand.integration_pya.in_service].color} ml5`">{{ brand.integration_pya.in_service == 'CLOSED_UNTIL' ? 'Cerrado hasta '+Util.Date(brand.integration_pya.opening_time, 'HH:mm') : dictStatusPya[brand.integration_pya.in_service].label }}</span>
                </div>
            </div>
        </div>
    </div>

    <div slot="General" v-if="config && Local.type == 'LOCAL'">
        
        <!-- Metodos de Pago -->
        <div>
            <div class="flex align-center mb20">
                <div class="f18 flex-fill">Métodos de Pago</div>
                <i class="options icon-plus" @click="modalPayMethods={}" v-tooltip="'Crear método de pago'"></i>
            </div>

            <div class="section mb20">

                <draggable
                :list="dragList"
                :animation="200"
                handle=".handle"
                group="methods">

                    <div v-for="(method, index) in dragList" :key="index" class="well mb10 selectable">
                        <div class="flex fill align-center" v-if="!['CASH', 'BANK_DEPOSIT', 'ONLINE', 'ONLINE_GETNET', 'ONLINE_MERCADO_PAGO'].includes(method.title)" @click="OpenModalPayMethods(method,index)">
                            <i class="icon icon-drag-handle handle"></i>
                            <div class="flex flex-fill align-center">
                                <div class="flex column flex-fill">{{method.title}} <span v-if="method.pending_payment" class="secondary-text">Pago Pendiente</span></div>
                                <div class="options icon-trash" v-tooltip="'Eliminar método de pago'" @click.stop="Confirm({
                                    text: 'Eliminar', 
                                    class: 'error-color', 
                                    title: '¿Eliminar método de pago?', 
                                    function: () => DeletePaymentMethod(index)
                                })"></div>
                            </div>
                        </div>
                        <div class="flex fill align-center" v-if="method.title == 'CASH'">
                            <i class="icon icon-drag-handle handle"></i>
                            <label class="flex-fill">
                                <input type="checkbox" v-model="config.accept_cash">Efectivo <div class="checkmark"></div>
                            </label>
                        </div>

                        <div class="flex align-center" v-if="method.title == 'BANK_DEPOSIT'">
                            <i class="icon icon-drag-handle handle"></i>
                            <label class="flex-fill align-center">
                                <input type="checkbox" v-model="config.accepts_bank_deposit"><div>
                                    <div>Transferencia</div>
                                    <div class="secondary-text" v-if="delivery.bank_settings.bank">{{delivery.bank_settings.bank}} - {{delivery.bank_settings.account}} {{delivery.bank_settings.account_number}}</div>
                                    <div class="secondary-text" v-else>Sin datos bancarios</div>
                                </div> <div class="checkmark"></div>
                            </label>
                            <button class="secondary" @click="modalBank=Util.Copy(delivery.bank_settings)">Editar</button>
                        </div>

                        <div class="flex align-center" v-if="method.title == 'ONLINE'">
                            <i class="icon icon-drag-handle handle"></i>
                            <label class="flex-fill align-center">
                                <input type="checkbox" v-model="config.accepts_online_payment" :disabled="!delivery.transbank_commerce"><div>
                                    <div class="flex align-center">Transbank <badge v-if="delivery.transbank_commerce" v-tooltip="'La integración con Transbank está activada'" pulse color="green" class="ml10" mini></badge></div>
                                    <div class="secondary-text" v-if="delivery.transbank_commerce">Pago Online</div>
                                    <div class="secondary-text" v-else>La integración con Transbank no está activada</div>
                                    <!-- <div class="secondary-text" v-if="delivery.transbank_commerce">ID Comercio: {{delivery.transbank_commerce}}</div>
                                    <div class="secondary-text" v-else>No hay un comercio de Transbank asociado</div> -->
                                </div> <div class="checkmark"></div>
                            </label>
                            <button class="secondary" @click="modalTransbank = Util.Copy(delivery)">Configurar</button>
                        </div>

                        <div class="flex align-center" v-if="method.title == 'ONLINE_GETNET'">
                            <i class="icon icon-drag-handle handle"></i>
                            <label class="flex-fill align-center">
                                <input type="checkbox" v-model="config.accepts_online_payment_getnet" :disabled="!delivery.getnet_commerce"><div>
                                    <div class="flex align-center">Getnet <badge v-if="delivery.getnet_commerce" v-tooltip="'La integración con Genet está activada'" pulse color="green" class="ml10" mini></badge></div>
                                    <div class="secondary-text" v-if="delivery.getnet_commerce">Pago Online con Getnet</div>
                                    <div class="secondary-text" v-else>La integración con Getnet no está activada</div>
                                    <!-- <div class="secondary-text" v-if="delivery.getnet_commerce || delivery.getnet_commerce_secretkey">ID Comercio: {{delivery.getnet_commerce}}</div> -->
                                </div> <div class="checkmark"></div>
                            </label>
                            <button class="secondary" @click="modalGetnet = Util.Copy(delivery)">Configurar</button>
                        </div>
                        
                        <div class="flex align-center" v-if="method.title == 'ONLINE_MERCADO_PAGO'">
                            <i class="icon icon-drag-handle handle"></i>
                            <label class="flex-fill align-center">
                                <input type="checkbox" v-model="config.accepts_online_payment_mercado_pago" :disabled="!delivery.mercado_pago_access_token"><div>
                                    <div class="flex align-center">Mercado Pago <badge v-if="delivery.mercado_pago_access_token" v-tooltip="'La integración con Mercado Pago está activada'" pulse color="green" class="ml10" mini></badge></div>
                                    <div class="secondary-text" v-if="delivery.mercado_pago_access_token">Pago Online con Mercado Pago</div>
                                    <div class="secondary-text" v-else>La integración con Mercado Pago no está activada</div>
                                    <!-- <div class="secondary-text" v-if="delivery.mercado_pago_user_id">ID Usuario: {{delivery.mercado_pago_user_id}}</div>
                                    <div class="secondary-text" v-if="!delivery.mercado_pago_access_token || delivery.mercado_pago_access_token == '' || !delivery.mercado_pago_webhook_secret || delivery.mercado_pago_webhook_secret == ''">No hay un comercio de Mercado Pago asociado (los pagos por Mercado Pago no funcionarán)</div> -->
                                </div> <div class="checkmark"></div>
                            </label>
                            <button class="secondary" @click="modalMercadoPago = Util.Copy(delivery)">Configurar</button>
                        </div>    
                    </div>

                </draggable>

                <div class="separator mt20 mb20"></div>
                <label>
                    <input type="checkbox" v-model="config.no_payment_select">Se debe seleccionar el método de pago<div class="checkmark"></div>
                </label>

                <div class="separator mt20 mb20"></div>
                <label>
                    <input type="checkbox" v-model="config.transbank_pos">Activar Transbank POS Integrado<div class="checkmark"></div>
                </label>
                <div v-if="config.transbank_pos" class="mt10">
                    <div class="hdvm mt10">
                        <input-select
                        v-model="transbankDebit"
                        label="Débito"
                        :items="transbankPaymentMethods">
                        </input-select>
                        <input-select
                        v-model="transbankCredit"
                        label="Crédito"
                        :items="transbankPaymentMethods">
                        </input-select>
                    </div>
                </div>
                <div class="separator mt20 mb20"></div>
                <div class="flex align-center">
                    <label class="flex-fill">
                        <input type="checkbox" v-model="config.mercado_pago_pos">Activar Mercado Pago POS Integrado<div class="checkmark"></div>
                    </label>
                    <button class="secondary" @click="OpenConfigTerminals()">Configurar Terminal</button>
                </div>
                <div v-if="config.mercado_pago_pos || config.transbank_pos">
                    <div class="separator mt20 mb20"></div>
                    <input-field 
                    label="PIN Ajustes de POS Integrado"
                    type="password"
                    placeholder="Pin para abrir los ajustes de POS Integrado"
                    v-model="config.transbank_pos_code">
                    </input-field>
                </div>

                <modal v-model="modalPayMethods" :dir="['right', 'center']" :modalClass="['fill', 'sm']" :title="modalPayMethods && modalPayMethods.edit ? 'Editar Método de Pago' : 'Nuevo Método de Pago'">
                    <div v-if="modalPayMethods" class="section">
                        
                        <input-field class="mb15" v-if="!modalPayMethods.edit"
                        v-model="modalPayMethods.title"
                        label="Método de Pago">
                        </input-field>
                        <div class="mb15" v-else>
                            <div class="bold">Método de Pago</div>
                            <div>{{modalPayMethods.title}}</div>
                        </div>

                        <label class="">
                            <input type="checkbox" v-model="modalPayMethods.pending_payment"><div>
                                <div class="bold">Pago Pendiente</div>    
                                <div class="secondary-text">El pago de las transacciones con este método quedarán pendientes y se deben liquidar después</div>
                            </div> <div class="checkmark"></div>
                        </label>
                        <input-text class="mt15"
                        v-model="modalPayMethods.payment_data"
                        label="Datos adicionales"
                        placeholder="(Opcional) Whatsapp +569XXXXXXXX"
                        description="Ingresa información adicional asociado al método de pago. Puedes colocar el formato 'Whatsapp +569XXXXXXXX' para habilitar un botón de contacto.">
                        </input-text>
                    </div>
                    
                    <button class="primary purple" slot="actions" v-if="modalPayMethods && modalPayMethods.edit" @click="EditPendingPayments()">Editar</button>
                    <button v-else slot="actions" class="primary purple" @click="AddPaymentMethod()">Aceptar</button>
                    
                </modal>

                <modal v-model="modalBank" title="Datos Transferencia Bancaria" dir="right" :modalClass="['fill', 'md right h100']">
                    <div v-if="modalBank" class="pa20">
                        <input-field class="mb15"
                        v-model="modalBank.name"
                        label="Nombre"
                        placeholder="Realizar deposito a nombre de...">
                        </input-field>
                        <input-field class="mb15"
                        v-model="modalBank.rut"
                        label="RUT"
                        placeholder="Realizar deposito a nombre de...">
                        </input-field>
                        <input-field class="mb15"
                        v-model="modalBank.bank"
                        label="Banco"
                        placeholder="Nombre del banco...">
                        </input-field>
                        <input-field class="mb15"
                        v-model="modalBank.account"
                        label="Tipo de Cuenta"
                        placeholder="">
                        </input-field>
                        <input-field class="mb15"
                        v-model="modalBank.account_number"
                        label="Número de Cuenta"
                        placeholder="">
                        </input-field>
                        <input-field class="mb15"
                        v-model="modalBank.email"
                        label="Email"
                        placeholder="Email para recibir el comprobante de pago">
                        </input-field>
                        <input-field
                        v-model="modalBank.phone"
                        label="Teléfono"
                        placeholder="Número para que el cliente pueda notificar la transferencia (Whatsapp)">
                        </input-field>
                    </div>
                    <button slot="actions" class="primary purple" @click="SaveBankData()">Guardar</button>
                </modal>

                <modal v-model="modalTransbank" dir="center" modalClass="sm" title="Transbank">
                    <div class="section" v-if="modalTransbank">
                        <input-field
                        v-model="modalTransbank.transbank_commerce"
                        label="Código de comercio Transbank"
                        description="Debes estar inscrito en Transbank con el proveedor Influye">
                        </input-field>
                    </div>
                    
                    <button v-if="delivery.transbank_commerce" slot="actions" class="primary error-color" @click="SaveTransbankID(true)">Eliminar</button>
                    <button slot="actions" class="primary purple" @click="SaveTransbankID()">Aceptar</button>
                    
                </modal>

                <modal v-model="modalGetnet" dir="center" modalClass="sm" title="Getnet">
                    <div class="section" v-if="modalGetnet">
                        <input-field
                        v-model="modalGetnet.getnet_commerce"
                        label="Código de Ingreso"
                        description="Debes estar inscrito en Getnet (conocido como Login)">
                        </input-field>

                        <input-field
                        class="mt10"
                        v-model="modalGetnet.getnet_commerce_secretkey"
                        label="Clave Secreta"
                        description="Debes estar inscrito en Getnet (conocido como Secretkey)">
                        </input-field>
                    </div>
                    
                    <button v-if="delivery.getnet_commerce" slot="actions" class="primary error-color" @click="SaveGetnetSetting(true)">Eliminar</button>
                    <button slot="actions" class="primary purple" @click="SaveGetnetSetting()">Guardar</button>
                    
                </modal>

                <modal v-model="modalMercadoPago" dir="center" modalClass="sm" title="Mercado Pago">
                    <div class="section" v-if="modalMercadoPago">
                        <input-field
                        v-model="modalMercadoPago.mercado_pago_access_token"
                        label="Token de Acceso"
                        description="Debes estar inscrito en Mercado Pago, conocido como Access Token">
                        </input-field>

                        <input-field
                        class="mt10"
                        v-model="modalMercadoPago.mercado_pago_webhook_secret"
                        label="Clave Secreta Webhook"
                        description="La podrás encontrar en 'Notificaciones' -> 'Webhook' -> 'Configurar notificaciones' de Mercado Pago Developers">
                        </input-field>
                    </div>
                    <button v-if="delivery.mercado_pago_access_token" slot="actions" class="primary error-color" @click="SaveMercadoPagoSetting(true)">Eliminar</button>
                    <!-- <button slot="actions" class="primary purple" @click="OpenConfigTerminals()">Configurar Terminal</button> -->
                    <button slot="actions" class="primary purple" @click="SaveMercadoPagoSetting()">Guardar</button>
                    
                </modal>

                <modal v-model="modalTerminal" title="Configuración de Terminales" dir="center" modalClass="md">
                    <div class="pa20" v-if="modalTerminal">
                        <div class="secondary-text">
                            <div>
                                <span class="bold">Modo Manual:</span> El cajero cobra manualmente tecleando el monto directo en la máquina.
                            </div>
                            <div>
                                <span class="bold">Modo Integrado:</span> La terminal recibe cobros automáticamente desde el POS.
                            </div>
                        </div>

                        <div v-for="(terminal, index) in modalTerminal" :key="index" class="mt10 well">
                            <div class="bold">{{ terminal.id }}</div>
                            <!-- <input-field 
                            type="text"
                            class="flex-fill"
                            label="Terminal"
                            v-model="terminal.id"
                            readonly>
                            </input-field> -->
                            <input-select class="mt5"
                            v-model="terminal.operating_mode"
                            :items="[{text: 'Modo Integrado' , value : 'PDV'}, {text : 'Modo Manual', value : 'STANDALONE'}]">
                            </input-select>
                        </div>

                    </div>
                    <button slot="actions" class="primary purple" @click="SaveTerminalConfig()">Guardar</button>
                </modal>
            
            </div>
        </div>

        <!-- Pedidos -->
        <div>
            <div class="flex align-center mb20">
                <div class="f18 flex-fill">Pedidos</div>
                <i class="options icon-dots-vertical" @click="Options([
                    {text: 'Reiniciar Número de Ticket', class: 'error-color', function: () => {ResetTicketNumber()}, confirm: `Se volverá a iniciar la enumeración de los pedidos por lo que el próximo pedido será el ticket número 1. Este cambio es irreversible, ¿desea continuar?`, icon: 'rollback'}
                ])"></i>
            </div>

            <div class="section mb20">

                <label class="mb10"><input type="checkbox" v-model="config.accept_serve"> Acepta pedidos para servir<div class="checkmark"></div></label>
                <label class="mb10"><input type="checkbox" v-model="config.accept_takeaway"> Acepta pedidos para llevar<div class="checkmark"></div></label>
                <label class="mb15"><input type="checkbox" v-model="config.accept_delivery">Acepta pedidos delivery<div class="checkmark"></div></label>
                
                <input-select class="mb15"
                v-model="config.default_sale"
                label="Tipo de pedido por defecto"
                :items="optionsDefaultSale">
                </input-select>

                <div class="separator mb20 mt20"></div>

                <label class="mb15">
                    <input type="checkbox" v-model="config.enabled_rut_field_orders"> 
                        <div class="flex column">
                            <div class="bold">Mostrar campo RUT en POS</div>
                        </div>
                    <div class="checkmark"></div>
                </label>

                <div class="separator mt20 mb20"></div>

                <label class="mb10" v-show="config.accept_serve"><input type="checkbox" v-model="config.default_tip_serve"> 
                    <div class="flex column">
                        <div class="bold">Propina por defecto en Pedidos para Servir (POS)</div>
                        <div class="secondary-text">Agrega 10% de propina al seleccionar el tipo de pedido Servir en el POS</div>
                    </div>
                    <div class="checkmark"></div>
                </label>

                <label class="mb10" v-show="config.accept_takeaway"><input type="checkbox" v-model="config.default_tip_takeaway"> 
                    <div class="flex column">
                        <div class="bold">Propina por defecto en Pedidos para Llevar (POS)</div>
                        <div class="secondary-text">Agrega 10% de propina al seleccionar el tipo de pedido Llevar en el POS</div>
                    </div>
                    <div class="checkmark"></div>
                </label>

                <label class="mb10" v-show="config.accept_delivery"><input type="checkbox" v-model="config.default_tip_delivery"> 
                    <div class="flex column">
                        <div class="bold">Propina por defecto en Pedidos Delivery (POS)</div>
                        <div class="secondary-text">Agrega 10% de propina al seleccionar el tipo de pedido Delivery en el POS</div>
                    </div>
                    <div class="checkmark"></div>
                </label>

                <label><input type="checkbox" v-model="config.default_tip_table"> 
                    <div class="flex column">
                        <div class="bold">Propina por defecto en Mesas</div>
                        <div class="secondary-text">Agrega 10% de propina al cerrar la mesa</div>
                    </div>
                    <div class="checkmark"></div>
                </label>

                <div class="separator mb20 mt20"></div>

                <input-select
                v-model="config.default_paid"
                label="Pago de un Pedido"
                description="Indica el momento en el cual un pedido es marcado como pagado"
                :items="optionsDefaultPaid">
                </input-select>

                <div class="separator mt20 mb20"></div>

                <input-select :items="optionsReduceInventoryCompleted"
                v-model="config.reduce_inventory_completed" label="Reducción de Inventario"
                description="Determina cuando se hace el desconteo de inventario al ingresar un pedido">
                </input-select>

            </div>
        </div>

        <!-- Pedidos Pendientes -->
        <div class="section mb20">
            
            <input-select class="mb20"
            v-model="config.orders_ticket_sort"
            label="Orden por defecto en Pedidos Pendientes"
            description="Define el orden inicial de los pedidos en Pedidos Pendientes"
            :items="optionsDefaultOrdersSort">
            </input-select>

            <div class="separator mb20 mt20"></div>
            
            <label><input type="checkbox" v-model="config.preparation_step"> <div class="flex column">
                <div class="bold">Paso de preparación</div>
                <div class="secondary-text">Los pedidos al ser ingresados quedan en estado pendiente y se deben marcar como 'En preparación' antes de completarlos</div>    
            </div><div class="checkmark"></div></label>            

            <div class="separator mb20 mt20"></div>

            <label><input type="checkbox" v-model="config.show_cancelled_orders"> 
                <div class="flex column">
                    <div class="bold">Mostrar pedidos cancelados</div>
                    <div class="secondary-text">Determina por cuanto tiempo (en minutos) se mostrarán los pedidos cancelados en Pedidos Pendientes</div>
                </div>
                <div class="checkmark"></div>
            </label>

            <div v-show="config.show_cancelled_orders" class="mt10">
                <input-field class="input-top"
                v-model="config.cancelled_transactions_time"
                type="int+"
                suffix=" minutos">
                </input-field>
                <div class="secondary-text well mini border bottom mb15">{{config.cancelled_transactions_time ? `Los pedidos cancelados se muestran por ${config.cancelled_transactions_time} minutos.` : 'Los pedidos cancelados no se muestran.'}}</div>
            </div>

            <div v-if="Local.modules.module_store">
                <div class="separator mt20 mb20"></div>

                <label><input type="checkbox" v-model="config.show_accepted_iap"> 
                    <div class="flex column">
                        <div class="bold">Mostrar los pedidos online recientemente ingresados por pagos online o confirmación del cliente</div>
                        <div class="secondary-text">Se mostrarán los pedidos online con estado "Ingresado". Al desactivar esta opción no se notificará cuando un pedido fue pagado o confirmado por el cliente y pasará directamente a Pendientes</div>
                    </div>
                    <div class="checkmark"></div>
                </label>
            </div>
        </div>

        <!-- Cocina -->
        <div class="section mb20">
            <input-select
            v-model="config.show_menu_description"
            label="Mostrar descripción de productos en Cocina"
            :items="optionsDefaultShowMenuDescription">
            </input-select>

            <div class="separator mb20 mt20"></div>

            <label><input type="checkbox" v-model="config.active_kitchen_delay"> <div class="flex column">
                <div class="bold">Color de productos con retraso en Cocina</div>
                <div class="secondary-text">Configura el tiempo de retraso que mostrará colores de los productos en cocina.</div>    
            </div><div class="checkmark"></div></label>
            <div v-if="config.active_kitchen_delay" class="hdvm mt15">
                <div>
                    <input-field class="input-top"
                    v-model="config.kitchen_late_time"
                    label="Producto atrasado"
                    description=""
                    type="int+"
                    suffix=" minutos">
                    </input-field>
                    <div class="secondary-text well mini border bottom" v-if="config.kitchen_late_time">Los productos después de {{config.kitchen_late_time}} minutos se mostrarán de color <span class="cyellow">amarillo.</span></div>
                    <div class="secondary-text well mini border bottom" v-else>No se destacarán productos atrasados.</div>
                </div>
                <div>
                    <input-field class="input-top"
                    v-model="config.kitchen_very_late_time"
                    label="Pedido muy atrasado"
                    description=""
                    type="int+"
                    suffix=" minutos">
                    </input-field>
                    <div class="secondary-text well mini border bottom" v-if="config.kitchen_very_late_time">Los productos después de {{config.kitchen_very_late_time}} minutos se mostrarán de color <span class="cred">rojo.</span></div>
                    <div class="secondary-text well mini border bottom" v-else>No se destacarán productos muy atrasados.</div>
                </div>
            </div>

            <div class="separator mb20 mt20"></div>

            <label><input type="checkbox" v-model="config.hide_kitchen_activation_time"> 
                <div class="flex column">
                    <div class="bold">Ocultar pedidos con tiempo de entrega en Cocina</div>
                    <div class="secondary-text">Define cuantos minutos antes de la hora de entrega se mostrarán los pedidos</div>
                </div>
                <div class="checkmark"></div>
            </label>

            <div v-show="config.hide_kitchen_activation_time" class="mt10">
                <input-field class="input-top"
                v-model="config.kitchen_activation_time"
                type="int+"
                suffix=" minutos">
                </input-field>
                <div class="well mini bottom border secondary-text">{{config.kitchen_activation_time ? `Los pedidos se mostrarán cuando falten ${config.kitchen_activation_time} minutos para su entrega.` : 'Los pedidos se muestran siempre.'}}</div>
            </div>

        </div>

        <!-- Repartos -->
        <div>
            <div class="f18 mb20">Repartos</div>
            <div class="section mb20">

                <div class="flex mb20">
                    <div class="flex column fill">
                        <div class="f18">Zonas de Reparto</div>
                        <div class="secondary-text">Se mostrarán como costos de reparto seleccionable en el punto de venta. Para pedidos online, un cliente podrá hacer un pedido solo si la dirección de envío está dentro de una zona de reparto (sólo las zonas con un polígono definido y habilitadas).</div>
                    </div>
                    <i class="options icon-dots-vertical" @click="Options([
                        {text: 'Exportar Zonas', function: () => {ExportZones()}, icon: 'download'},
                        {text: 'Importar Zonas', function: () => {modalImportMaps = {}}, icon: 'upload'},
                        {text: 'Nueva Zona', function: () => {modalZone={label: '', radio: null, cost: 0}}, icon: 'plus'}
                    ])"></i>
                </div>

                <div class="hdvm" v-if="delivery.zones.length">
                
                    <div class="ofy" :style="desktop ? {padding: '5px', margin: '-5px', marginRight: '5px', marginLeft: '-10px !important', maxHeight: '400px'} : {maxHeight: '400px'}">
                        <div :class="`selectable well mb10 ${currentPolygon === index ? 'selected' : ''}`"
                        v-for="(zone, index) in delivery.zones"
                        :key="index"
                        @click="SelectPolygon(index);">
                            <div class="fill flex align-center">
                                <!--<i :class="`options icon-circle${currentPolygon === index ? '-check cpurple' : ''} mr5`" @click.stop="SelectPolygon(index)"></i>-->
                                <div class="flex column flex-fill">
                                    <div :class="`bold ${currentPolygon === index ? 'cselected' : ''}`">{{zone.label ? zone.label : `Zona ${index+1}`}}</div>
                                    <div class="secondary-text">Costo {{Util.Price(zone.cost)}}</div>
                                    <div class="secondary-text" v-if="zone.polygon.length >= 3 && !zone.disabled">Habilitada para pedidos online</div>
                                </div>
                                <i class="options icon-dots-vertical" @click.stop="Options([
                                    {text: 'Eliminar', function: () => {RemovePolygon(index)}, class: 'error-color', confirm: '¿Eliminar zona de reparto?', icon: 'trash'},
                                    {text: 'Editar', function: () => {ModalEditZone(zone, index)}, icon: 'edit'},
                                ])"></i>
                            </div>
                        </div>
                    </div>

                    <map-component style="height: 400px; border-radius: 10px"
                    ref="map"
                    v-model="local"
                    :useMarker="true"
                    :canEditPolygon="currentPolygon!==null"
                    @OnPolygonChanged="UpdatePolygon($event)">
                    </map-component>

                </div>
                <div v-else class="secondary-text ta-center mt10">No hay zonas de reparto</div>

                <div class="separator mt20 mb20"></div>

                <label class="mb10"><input type="checkbox" v-model="config.customer_auto_select_delivery_cost"> Cargar zona de reparto automáticamente de clientes en POS (sólo si se asignó una zona anteriormente)<div class="checkmark"></div></label>
                
                <label><input type="checkbox" v-model="config.delivery_cost_require">Seleccionar zona de reparto obligatoriamente en POS<div class="checkmark"></div></label>

            </div>

            <div class="section mb20">

                <div class="flex mb20">
                    <div class="flex column fill">
                        <div class="f18">Reglas de Reparto</div>
                        <div class="secondary-text">Se pueden configurar reglas para aplicar costos de reparto de forma automatica si el valor total es mayor o igual a la condicion aplicada.</div>
                    </div>
                    <i class="options icon-dots-vertical" @click="Options([
                        //{text: 'Definir Zona Circular', function: () => {modalRadio = {radio: 0, cost: 0}}},
                        {text: 'Nueva Regla', function: () => {modalRule={label: '',  cost: 0, condition: 0, delivery_zones: []}}, icon: 'plus'}
                    ])"></i>
                </div>

                <div class="hdvm" v-if="delivery.rules.length">

                    <div class="ofy" :style="desktop ? {padding: '5px', margin: '-5px', marginRight: '5px', marginLeft: '5px', maxHeight: '400px'} : {maxHeight: '400px'}">
                        <div :class="`selectable well mb10`"
                        v-for="(rule, index) in delivery.rules"
                        :key="index"
                        @click="ModaLEditRule(rule, index)">
                            <div class="fill flex align-center">
                                <!--<i :class="`options icon-circle${currentPolygon === index ? '-check cpurple' : ''} mr5`" @click.stop="SelectPolygon(index)"></i>-->
                                <div class="flex column flex-fill">
                                    <div class="bold">{{rule.label ? rule.label : `Regla ${index+1}`}}</div>
                                    <div class="secondary-text">Los pedidos que sean mayor o igual a {{Util.Price(rule.condition)}} tendran costo de reparto {{Util.Price(rule.cost)}}</div>
                                    <div class="secondary-text" v-if="!rule.disabled">Habilitada para pedidos online</div>
                                    <div class="secondary-text" v-if="rule.delivery_zones && rule.delivery_zones.length">La regla solo se aplicará para las zonas: <span v-for="(zone, i) in rule.delivery_zones" :key="i">{{ i ? ', ' : '' }}{{ zone }}</span></div>
                                </div>
                                <i class="options icon-dots-vertical" @click.stop="Options([
                                    {text: 'Eliminar', function: () => {RemoveRule(index)}, class: 'error-color', confirm: '¿Eliminar regla de reparto?', icon: 'trash'},
                                    {text: 'Editar', function: () => {ModaLEditRule(rule, index)}, icon: 'edit'},
                                ])"></i>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-else class="secondary-text ta-center mt10">No hay reglas de reparto</div>


            <!-- Modal regla -->
                <modal v-model="modalRule" dir="center" modalClass="sm" title="Regla">
                    <div class="section" v-if="modalRule">

                        <input-field v-model="modalRule.label" class="mb15"
                        label="Nombre" placeholder="(Opcional)">
                        </input-field>

                        <input-field class="mb15"
                        v-model="modalRule.cost"
                        label="Costo de Reparto"
                        type="int+"
                        prefix="$">
                        </input-field>

                        <input-select :cleareable="true" 
                        :multiple="true" 
                        :triggerFirstValueChanged="false" 
                        placeholder="Cualquier Zona" placeholderClass=""
                        class="mb15" v-model="modalRule.delivery_zones" label="Zonas de Reparto" :items="LoadZoneDelivery"></input-select>

                        <input-field class="mb15"
                        v-model="modalRule.condition"
                        label="Valor Condicional"
                        type="int+"
                        prefix="mayor o igual $">
                        </input-field>
                        <label>
                            <input type="checkbox" v-model="modalRule.disabled"><div>Deshabilitado (Pedidos Online)</div> <div class="checkmark"></div>
                        </label>

                    </div>
                    
                    <button slot="actions" v-if="modalRule" class="primary purple" @click="AddRule()">{{modalRule.edit!==undefined ? 'Editar Regla' : 'Agregar Regla'}}</button>
                    
                </modal>

            </div>

            <!-- Google Maps API -->
            <div class="section mb20">
                <div class="flex align-center flex-fill mb10">
                    <div class="flex align-center f18 flex-fill">API Google Maps <badge v-if="config.google_maps_api_key" v-tooltip="'La integración con Google Maps API está activada'" pulse color="green" class="ml10" mini></badge></div>
                    <button class="secondary" @click="modalGoogleMapsApi = {key: config.google_maps_api_key}">Configurar</button>
                </div>
                <div class="secondary-text" v-if="config.google_maps_api_key">Se esta usando la API de Google Maps para obtener direcciones</div>
                <div class="secondary-text" v-else>Usa la API de Google para obtener direcciones, si no se puede obtener se usarán las direcciones proporcionadas por Influye</div>
            </div>

            <div class="section mb20" v-if="integration_courier && Local.modules.module_pya_courier">
                <div class="flex align-center mb10">
                    <div class="f18 flex flex-fill align-center">PedidosYa Courier <badge v-if="integration_courier.is_active" v-tooltip="'La integración con PedidosYa Courier está activada'" pulse color="green" class="ml10" mini></badge></div>
                    <button class="secondary" @click="modalPya=Util.Copy(integration_courier)">Configurar</button>
                </div>

                <div v-if="!integration_courier || !integration_courier.is_active" class="secondary-text mt10">La integración con PedidosYa Courier no está activada</div>
                <div v-else class="secondary-text mt10">La integración con PedidosYa Courier esta activada</div>
                <!-- <div class="secondary-text" v-if="integration_courier.username">La integración con PedidosYa Courier esta activada con el usuario {{integration_courier.username}} <i class="icon icon-circle-check cpurple ml5"></i></div> -->
            </div>

        </div>

        <!-- Integraciones -->
        <div v-if="Local.modules.module_ue || Local.modules.module_pya">
            <div class="f18 mb20">Pedidos Externos</div>
            <div class="section mb20" v-if="integration_ue && Local.modules.module_ue"> 

                <div class="flex align-center mb10">
                    <div class="f18 flex flex-fill align-center">Uber Eats <badge v-if="integration_ue.is_active" v-tooltip="'La integración con Uber Eats está activada'" pulse color="green" class="ml10" mini></badge></div>
                    <button class="secondary" @click="OpenModalUE(integration_ue)">Configurar</button>
                </div>

                <div v-if="!integration_ue || !integration_ue.is_active" class="secondary-text mt10">
                    La integración con Uber Eats no está activada
                </div>
                <div v-else class="secondary-text mt10">
                    La integración con Uber Eats está activada 
                </div>
                <div class="secondary-text" v-if="integration_ue && integration_ue.is_active && integration_ue.implement_menu">Sincronización de Menú activada</div>
                <div v-if="integration_ue.is_active && integration_ue.status" class="secondary-text">
                    Estado:
                    <span :class="[integration_ue.status == 'ONLINE' ? 'cgreen' : 'cred', 'ml5']">
                        {{ integration_ue.status == 'ONLINE' ? 'Abierto' : 'Cerrado' }}
                        <span v-if="integration_ue.status == 'OFFLINE' && integration_ue.is_offline_until">hasta {{ Util.Date(integration_ue.is_offline_until, 'HH:mm') }}</span>
                    </span>
                </div>
            </div>

            <div class="section mb20" v-if="integration_pya && Local.modules.module_pya">
                <div class="flex align-center mb10">
                    <div class="f18 flex flex-fill align-center">PedidosYa <badge v-if="integration_pya.is_active" v-tooltip="'La integración con PedidosYa está activada'" pulse color="green" class="ml10" mini></badge></div>
                    <button class="secondary" @click="modalPyaIntegration=Util.Copy(integration_pya)">Configurar</button>
                </div>

                <div v-if="!integration_pya.is_active" class="secondary-text mt10">La integración con PedidosYa no está activada</div>
                <div v-else class="secondary-text mt10">La integración con PedidosYa esta activada</div>
                <div class="secondary-text" v-if="integration_pya.is_active && integration_pya.implement_menu">Sincronización de Menú activada</div>
                <div v-if="integration_pya.is_active && integration_pya.in_service" class="secondary-text">
                    <div class="secondary-text">Estado: <span :class="`${dictStatusPya[integration_pya.in_service].color} ml5`">{{ integration_pya.in_service == 'CLOSED_UNTIL'? 'Cerrado hasta '+Util.Date(integration_pya.opening_time, 'HH:mm') : dictStatusPya[integration_pya.in_service].label }}</span></div>
                </div>
            </div>

        </div>
        
        <!-- Turnos -->
        <div>
            <div class="f18 mb20">Turnos</div>
            <div class="section mb20">
                <label class=""><input type="checkbox" v-model="config.only_one_turn_active"> Turno único<div class="checkmark"></div></label>
                <label class="mt15 ml30" v-if="config.only_one_turn_active">
                    <input type="checkbox" v-model="config.same_account_open_close_turn"> 
                    <div class="flex column">
                        <div class="">Restringir apertura y cierra del turno a la misma cuenta</div>
                        <div class="secondary-text">Al estar habilitada esta opción el usuario que abre turno es quien debe cerrarlo. De lo contrario, cualquier otro usuario puede realizar el cierre de turno.</div>
                    </div> 
                    <div class="checkmark"></div>
                </label>
                <label class="mt10"><input type="checkbox" v-model="config.not_add_initial_cash"> No sumar efectivo inicial<div class="checkmark"></div></label>
                <div class="mt15 flex align-center">
                    <div class="flex-fill">
                        <div class="flex flex-fill">
                            <div class="bold flex flex-fill align-center">Métodos de Pago en Cierre Fantasma</div>
                            <button class="secondary" @click="OpenModalHideMethodsGhostClose()">Editar</button>
                        </div>
                        <div class="mt10 well" v-if="Object.values(hideMethodsGhostClose).some(obj => !obj.hide)">
                            <div
                            class="secondary-text"
                            v-for="(value, key) in hideMethodsGhostClose"
                            :key="key" v-show="!value.hide">
                                
                                {{ Util.PayMethod(key)}}<span v-if="value.declaration"> (Montos con propina incluida)</span>
                                 
                            </div>
                        </div>
                        <div v-else class="secondary-text"> No hay métodos de pago para mostrar en cierre fantasma</div>
                    </div>
                    
                </div>
            </div>
        </div>

        <!-- Mensajeria -->
        <div>

            <div class="f18 mb20">Mensajeria</div>

            <div class="section flex column gap15">

                <input-text
                v-model="config.default_difussion_message"
                label="Mensaje a Clientes"
                description="Mensaje de Whatsapp por defecto a clientes al contactar. La palabra {name} (incluyendo las llaves) serán remplazadas por el nombre del cliente."
                placeholder="Ejemplo: Hola {name}"
                :keywords="{'{name}': 'Nombre', '{survey}': 'Link Encuesta'}"
                showKeywords>
                </input-text>

                <input-text
                v-model="config.default_voucher_message"
                label="Mensaje al Enviar Voucher"
                description="Mensaje de Whatsapp por defecto a clientes al enviar un voucher virtual. La palabra {name} (incluyendo las llaves) serán remplazadas por el nombre del cliente."
                placeholder="Ejemplo: Hola {name}"
                :keywords="{'{name}': 'Nombre'}"
                showKeywords>
                </input-text>

                <input-text v-if="Local.modules.module_sii_boleta"
                v-model="config.default_boleta_message"
                label="Mensaje al Enviar Boleta"
                description="Mensaje de Whatsapp por defecto a clientes al enviar una boleta electrónica. La palabra {name} (incluyendo las llaves) serán remplazadas por el nombre del cliente."
                placeholder="Ejemplo: Hola {name}"
                :keywords="{'{name}': 'Nombre'}"
                showKeywords>
                </input-text>

                <input-text 
                v-model="config.default_order_online_message"
                label="Mensaje al Ingresar Pedido"
                description="Mensaje de Whatsapp por defecto a clientes al ingresar un pedido. La palabra {name} (incluyendo las llaves) serán remplazadas por el nombre del cliente."
                placeholder="Ejemplo: Hola {name}"
                :keywords="{'{name}': 'Nombre'}"
                showKeywords>
                </input-text>

                <input-text
                v-model="config.default_delivery_message"
                label="Mensaje de Reparto"
                description="Mensaje de Whatsapp por defecto a clientes al enviar un pedido. Las palabras {name} y {address} (incluyendo las llaves) serán remplazadas por el nombre y la dirección del cliente respectivamente."
                placeholder="Ejemplo: Hola {name}, tu pedido va en camino a {address}!"
                :keywords="{'{name}': 'Nombre', '{address}': 'Dirección', '{survey}': 'Link Encuesta'}"
                showKeywords>
                </input-text>

                <input-text
                v-model="config.default_message_delivery_driver"
                label="Mensaje para Repartidores"
                description="Mensaje de Whatsapp por defecto a repartidores al despachar pedidos delivery. Las palabras {ticket}, {name}, {phone}, {address} y {gps} (incluyendo las llaves) serán remplazadas por el número de pedido, nombre del cliente, contacto del cliente, dirección del cliente y link de Google Maps respectivamente."
                placeholder="Ejemplo: Pedido #{ticket} Nombre: {name} Contacto: {phone} Dirección: {address} {gps}"
                :keywords="{'{ticket}': 'Ticket', '{name}': 'Nombre (cliente)', '{phone}': 'Contacto (cliente)', '{address}': 'Dirección', '{gps}': 'Link Google Maps'}"
                showKeywords>
                </input-text>
            </div>
        </div>

    </div>
    
    <modal v-model="modalProfile" title="Editar Perfil" dir="right" :modalClass="['fill', 'right h100 md']">

        <div v-if="modalProfile" class="pa20">

            <input-image v-if="!local.id_franchise"
            label="Logo"
            v-model="modalProfile.logotype"
            path="logos/" 
            class="mb15">
            </input-image>

            <!--<input-color v-model="local.color"></input-color>-->
            <input-field
            v-if="modalProfile.type == 'BRAND'"
            class="mb15"
            v-model="modalProfile.name" 
            label="Nombre"
            >
            </input-field> 

            <div v-if="local.type == 'LOCAL'">
                <input-field 
                v-model="modalProfile.address" 
                label="Dirección" 
                class="mb15">
                </input-field>

                <div class="hs">
                    <input-field 
                    v-model="modalProfile.latitude" 
                    label="Latitud" 
                    class="mb15">
                    </input-field>
                
                    <input-field 
                    v-model="modalProfile.longitude" 
                    label="Longitud" 
                    class="mb15">
                    </input-field>
                </div>

                <div v-if="desktop" class="contain mb15" style="width: 100%; height: 350px; border-radius: 10px">
                    <map-component v-model="modalProfile" 
                    :useMarker="true" 
                    :canEditMarker="true"
                    canSearch geocode
                    @OnMarkerChanged="UpdateLocation($event)">
                    </map-component>
                </div>
            </div>

            <input-field 
            v-model="modalProfile.phone" 
            label="Teléfono" 
            placeholder="(Opcional. Ejemplo: +56912341234 - (41) 123 1234)"
            description="Puedes agregar múltiples números separándolos con un guión"
            class="mb15">
            </input-field>

            <input-select v-if="modalProfile.type != 'BRAND'" v-model="modalProfile.timezone" class="mb15"
            :items="timezoneItems"
            label="Zona Horaria">
            </input-select>

            <input-field class="mb15"
            v-model="modalProfile.instagram" 
            label="Instagram"
            placeholder="(Opcional. Link al perfil Ej: https://www.instagram.com/influyeapp/)">
            </input-field>    

            <input-field 
            v-model="modalProfile.public_email" 
            label="Email Público"
            placeholder="(Opcional. Se muestra en página de comercio)">
            </input-field>    
            
            <div class="separator mt20 mb20"></div>

            <input-field
            v-if="modalProfile.type != 'BRAND'"
            v-model="modalProfile.email" 
            label="Email Administrativo"
            description="Correo que utilizará Influye para notificar al negocio">
            </input-field>    

            <input-color class="mt15"
            label="Color de Marca"
            v-model="modalProfile.color">
            </input-color>

            <div v-if="(Auth.role == 'admin' || Auth.role == 'sub_admin') && modalProfile.type != 'BRAND'">
                <div class="separator mt20 mb20"></div>
                <input-field class="mb15" 
                v-model="modalProfile.segment" 
                label="Segmento">
                </input-field> 
                <input-field class="mb15" 
                v-model="modalProfile.city" 
                label="Ciudad">
                </input-field> 
                <input-field class="mb15" 
                v-model="modalProfile.region" 
                label="Región">
                </input-field> 
                <input-field class="mb15" 
                v-model="modalProfile.country" 
                label="País">
                </input-field> 
            </div>

        </div>

        <button class="primary purple" slot="actions" @click="SaveProfile()">Guardar</button>

    </modal>

    <modal v-model="modalNewBrand" :dir="['right', 'center']" :modalClass="['fill', 'sm']" title="Nueva Marca">
        <div class="pa20" v-if="modalNewBrand">

            <input-field
            v-model="modalNewBrand.name"
            label="Nombre">
            </input-field>            
            
        </div>
        <div slot="actions">
            <button @click="CreateBrand()" class="primary purple">Crear</button>
        </div>
    </modal>

    <modal v-model="modalPyaIntegrationStatusService" dir="center" modalClass="sm" title="Estado PedidosYa">
        <div class="section" v-if="modalPyaIntegrationStatusService">
            <input-select class="restriction-option"
            label="Estado"
            v-model="modalPyaIntegrationStatusService.futureStatus"
            :items="[
                {value: 'CLOSED_UNTIL', text: 'Cerrado hasta --:--'}, 
                {value: 'CLOSED', text: 'Cerrado'},
                // {value: 'INACTIVE', text: 'Inactivo'},
                {value: 'UNKNOWN', text: 'Desconocido'},
                {value: 'OPEN', text: 'Abierto'},
                {value: 'CLOSED_TODAY', text: 'Cerrado por hoy'},
            ]">
            </input-select>

            <input-date v-if="modalPyaIntegrationStatusService.futureStatus == 'CLOSED_UNTIL'" class="sm mt20"
            label="Hora hasta la cual estará cerrado"
            v-model="modalPyaIntegrationStatusService.closingMinutes"
            type="TIME"
            format="HH:mm">
            </input-date>
        </div>
        <button slot="actions" v-if="modalPyaIntegrationStatusService" class="primary purple" @click="UpdateServicePya(modalPyaIntegrationStatusService)">Editar</button>
    </modal>

    <modal v-model="modalUE" title="Configuración Uber Eats" dir="right" :modalClass="['fill', 'right md h100']">
        <div v-if="modalUE && !modalUE.is_active" class="pa20">
            <div class="f18 mb10">Conecta tu local con Uber Eats</div>
            <div class="secondary-text mb20">Vincula la sucursal correspondiente para gestionar sus pedidos desde Influye.</div>
            <div class="well mb15">
                <div class="bold mb5">1. Ingresa a Uber Eats</div>
                <div class="secondary-text">Usa la cuenta que administra tu sucursal y autoriza la conexión con Influye. Se abrirá una nueva pestaña.</div>
            </div>
            <div class="well mb15">
                <div class="bold mb5">2. Vincula tu sucursal</div>
                <div class="secondary-text">Selecciona el local correcto y completa la homologación en la página de autorización.</div>
            </div>
            <div class="well mb15">
                <div class="bold mb5">3. Activa la integración</div>
                <div class="secondary-text">Una vez vinculada la sucursal, vuelve aquí y presiona Activar para configurar la integración.</div>
            </div>
            <button class="primary purple" v-if="Auth.role == 'admin' || Auth.role == 'local_admin'" @click="MandatoryFunctionsUE()">Ingresar a Uber Eats</button>
        </div>

        <div v-if="modalUE && modalUE.is_active" class="pa20">
            <div v-if="modalUE.status" class="flex mb15">
                <div class="flex column flex-fill">
                    <div class="bold">Estado</div>
                    <div :class="modalUE.status == 'ONLINE' ? 'cgreen' : 'cred'">
                        {{ modalUE.status === 'ONLINE' ? 'Activo' : 'Inactivo' }}
                        <span v-if="modalUE.is_offline_until">
                            Hasta {{ Util.Date(modalUE.is_offline_until, 'DD/MM/YYYY HH:mm') }}
                        </span>
                    </div>

                </div>
                <button class="secondary" @click="modalStatusUe = {id: modalUE.id}">Editar</button>
            </div>

            <input-date class="mb15"
            v-model="modalUE.prep_time"
            label="Tiempo de preparación"
            type="TIME"
            format="HH:mm">
            </input-date>

            <input-toggle class="mb15"
            v-model="modalUE.implement_menu"
            label="Sincronización de menú"
            description="Se sobrescribirá el menú de Uber Eats con el menú de Influye">
            </input-toggle>

            <div v-if="modalUE.implement_menu">
                <div class="flex mb20">
                    <div class="flex-fill">
                        <div>Horarios</div>
                        <div class="secondary-text">Días y horarios cuando un cliente puede hacer pedidos. Este horario se enviará al exportar el menú.</div>
                    </div>

                    <i class="options icon-plus" @click="modalSchedule={day: 'monday', start: '00:00', finish: '23:59', delivery: true, takeaway: true}"></i>
                </div>
                
                <div class="well mb10 selectable flex align-center" v-for="(schedule, index) in modalUE.schedule" :key="index"
                @click="modalSchedule = Util.Copy(schedule, {index: index})">
                    <div class="flex-fill">
                        <div class="bold">{{Util.DictDaysEnToEs[schedule.day]}}</div>
                        <div class="secondary-text">{{schedule.start}} - {{schedule.finish}}</div>
                    </div>
                    <!-- <i class="options icon-delivery" :style="{color: schedule.delivery ? 'var(--color-delivery-transit)' : 'var(--gray-2)'}" @click.stop="$set(schedule, 'delivery', !schedule.delivery)" v-tooltip="'Activar para pedidos Delivery'"></i> -->
                    <!-- <i class="options icon-bag" :style="{color: schedule.takeaway ? 'var(--color-takeaway-time)' : 'var(--gray-2)'}" @click.stop="$set(schedule, 'takeaway', !schedule.takeaway)" v-tooltip="'Activar para pedidos para LLevar'"></i> -->
                    <i class="options icon-trash ml5" @click.stop="Confirm({
                        text: 'Eliminar',
                        title: '¿Eliminar horario?',
                        class: 'error-color',
                        function: () => {modalUE.schedule.splice(index, 1)}
                    })"></i>
                </div>
            </div>
        </div>

        <div v-if="modalUE && modalUE.id_store && (Auth.role == 'admin' || Auth.role == 'local_admin')" class="pa20">
            <div class="well">
                <div class="bold mb5">Desvinculación con Uber Eats</div>
                <div class="secondary-text mb15">Deshomologar elimina la vinculación de esta sucursal con Influye. Para conectarla nuevamente deberás repetir la autorización.</div>
                <button class="secondary error-color" @click="Confirm({
                    title: '¿Deshomologar esta sucursal de Uber Eats?',
                    text: 'Deshomologar',
                    class: 'error-color',
                    function: () => UnlinkUE()
                })">Deshomologar</button>
                <button v-if="modalUE.is_active" class="primary mt10" @click="MandatoryFunctionsUE()">Ingresar a Uber Eats</button>
            </div>
        </div>

        <button class="primary error-color" v-if="modalUE && modalUE.is_active" slot="actions" @click="SaveUE(false)">Desactivar</button>
        <button class="primary purple" v-if="modalUE && modalUE.is_active" slot="actions" @click="SaveUESettings()">Guardar</button>
        <button class="primary purple" v-if="!modalUE || !modalUE.is_active" slot="actions" @click="SaveUE(true)">Activar</button>
    </modal>

    <modal v-model="modalSchedule" :dir="['right', 'center']" :modalClass="['fill', 'sm']" :title="modalSchedule && 'index' in modalSchedule ? 'Editar Horario' : 'Nuevo Horario'">
        <div class="pa20" v-if="modalSchedule">
            <input-select v-if="!isTimestampDate(modalSchedule.day)" class="mb15"
            label="Día"
            :items="[{text: 'Lunes', value: 'monday'}, {text: 'Martes', value: 'tuesday'}, {text: 'Miércoles', value: 'wednesday'} ,{text: 'Jueves', value: 'thursday'}, {text: 'Viernes', value: 'friday'}, {text: 'Sábado', value: 'saturday'}, {text: 'Domingo', value: 'sunday'}, {text: 'Semana Completa', value: 'WEEK', if: !('index' in modalSchedule)}]"
            v-model="modalSchedule.day">
            </input-select>
            
            <input-date v-else class="mb15"
            label="Fecha"
            v-model="modalSchedule.day"
            type="DATE"
            format="timestamp"
            minDate="today">
            </input-date>
            <div class="hs mb20">
                <input-date class="sm"
                :label="isTimestampDate(modalSchedule.day) ? 'Inicio' : 'Apertura'"
                v-model="modalSchedule.start"
                type="TIME"
                format="HH:mm">
                </input-date>
                
                <input-date class="sm"
                :label="isTimestampDate(modalSchedule.day) ? 'Fin' : 'Clausura'"
                v-model="modalSchedule.finish"
                type="TIME"
                format="HH:mm">
                </input-date>
            </div>
            <!-- <label class="mb5">
                <input type="checkbox" v-model="modalSchedule.delivery"> {{isTimestampDate(modalSchedule.day) ? "Cerrado" : "Habilitado" }} para pedidos Delivery <div class="checkmark"></div>
            </label>
            <label class="">
                <input type="checkbox" v-model="modalSchedule.takeaway"> {{isTimestampDate(modalSchedule.day) ? "Cerrado" : "Habilitado" }} para pedidos para Retiro <div class="checkmark"></div>
            </label> -->
        </div>
        <button class="primary purple" slot="actions" @click="SaveSchedule">Guardar</button>
    </modal>

    <modal v-model="modalSetBussyMode" title="Modo Ocupado Uber Eats" dir="center" modalClass="sm">
        <div class="section pa20" v-if="modalSetBussyMode">
            <input-date class="mb15"
            v-model="modalSetBussyMode.delay_until"
            label="Ocupado hasta"
            type="DATETIME"
            format="DD/MM/YYYY HH:mm">
            </input-date>

            <input-field class=""
            v-model="modalSetBussyMode.delay_duration"
            label="Duración de demora (en segundos)">
            </input-field>
        </div>
        <button slot="actions" class="primary purple" v-if="modalSetBussyMode" @click="UpdateBussyModeUE()">Guardar</button>
    </modal>

    <modal v-model="modalStatusUe" title="Estado Uber Eats" dir="center" modalClass="sm">
        <div class="section pa20" v-if="modalStatusUe">
            <input-select class="mb15"
            v-model="modalStatusUe.status"
            label="Estado"
            :items="[
                {value: 'ONLINE', text: 'Activo'},
                {value: 'OFFLINE', text: 'Inactivo'},
            ]">
            </input-select>

            <input-date class="mb15"
            v-if="modalStatusUe.status == 'OFFLINE'"
            v-model="modalStatusUe.is_offline_until"
            label="Próximo cambio de estado"
            type="DATETIME"
            format="DD/MM/YYYY HH:mm">
            </input-date>

            <input-field class=""
            v-model="modalStatusUe.reason"
            label="Motivo"
            placeholder="(Opcional)">
            </input-field>
        </div>
        <button slot="actions" class="primary purple" v-if="modalStatusUe" @click="UpdateStatusUE()">Guardar</button>
    </modal>

    <modal v-model="modalPya" title="Configuración PedidosYa Courier" dir="right" :modalClass="['fill', 'right h100 md']">

        <div v-if="modalPya && (!integration_courier || !integration_courier.is_active)" class="pa20">
            <div class="secondary-text mb15">Debes estar registrado con PedidosYa Courier</div>

            <input-field class="mb15"
            v-model="modalPya.token"
            label="Token"
            placeholder="Token">
            </input-field>

            <!-- <input-field class="mb15"
            v-model="modalPya.username"
            label="Usuario"
            placeholder="Email">
            </input-field>

            <input-field class="mb15"
            v-model="modalPya.password"
            label="Contraseña"
            type="password"
            placeholder="Contraseña">
            </input-field>

            <input-field class="mb15"
            v-model="modalPya.client_id"
            label="ID de Cliente"
            placeholder="Client ID">
            </input-field>

            <input-field class=""
            v-model="modalPya.client_secret"
            label="Secreto de Cliente"
            placeholder="Client Secret"
            type="password">
            </input-field> -->
        </div>

        <tabs :tabs="['Datos', 'Ajustes']" v-if="modalPya && integration_courier && integration_courier.is_active" keyByTab>

            <div slot="Datos" class="pa20">

                <!-- <div class="well secondary-text mb15" v-if="integration.username">La integración esta activada con el usuario {{integration.username}}</div> -->

                <div class="secondary-text mb15">Datos que recibirá el repartidor de PedidosYa al recoger el pedido</div>

                <input-field class="mb15"
                v-model="modalPya.name"
                label="Nombre"
                placeholder="(Requerido)">
                </input-field>

                <input-field class="mb15"
                v-model="modalPya.phone"
                label="Teléfono"
                placeholder="(Requerido)">
                </input-field>

                <input-field class="mb15"
                v-model="modalPya.city"
                label="Ciudad"
                placeholder="(Requerido)">
                </input-field>

                <input-field class="mb15"
                v-model="modalPya.address_street"
                label="Dirección"
                placeholder="(Requerido)">
                </input-field>

                <input-field class="mb15"
                v-model="modalPya.address_additional"
                label="Comentario de Dirección"
                placeholder="(Opcional. Información addicional como número de piso)">
                </input-field>

                <input-field class=""
                v-model="modalPya.instructions"
                label="Instrucciones"
                description="Instrucciones adicionales para el repartidor al recoger el pedido"
                placeholder="(Opcional)">
                </input-field>
            </div>

            <div slot="Ajustes" class="pa20">
                <input-toggle class="mb15"
                v-model="modalPya.autocomplete"
                label="Autocompletar Pedidos"
                description="Se completará automaticamente la transacción cuando PedidosYa haya entregado el pedido">
                </input-toggle>

                <input-toggle class="mb15"
                v-model="modalPya.external_delivery"
                label="Reparto externo"
                description="Se registrará el costo de reparto como reparto externo">
                </input-toggle>

                <input-toggle class="mb15"
                v-model="modalPya.send_emails"
                label="Enviar notificaciones"
                description="Se enviarán los emails notificaciones de PedidosYa">
                </input-toggle>

                <input-toggle class="mb15"
                v-model="modalPya.apply_discount"
                label="Aplicar descuento"
                description="Se aplicará automáticamente un descuento al reparto de PedidosYa">
                </input-toggle>

                <div class="well" v-if="modalPya.apply_discount">
                    <div class="hdvm">
                        <input-field
                        label="Descuento"
                        type="int+"
                        v-model="modalPya.discount_value"
                        :prefix="modalPya.discount_type == '$' ? '$' : ''"
                        :suffix="modalPya.discount_type == '%' ? '%' : ''">
                        </input-field>

                        <input-select
                        label="Tipo"
                        :items="[{value: '%', text: 'Porcentaje de descuento'}, {value: '$', text: 'Descuento en pesos'}]"
                        v-model="modalPya.discount_type">
                        </input-select>
                    </div>

                    <input-field class="mt15" v-if="modalPya.discount_type == '%'"
                    label="Máximo"
                    type="int+"
                    v-model="modalPya.discount_max">
                    </input-field>
                </div>

            </div>

        </tabs>
        
        <button class="primary error-color" v-if="integration_courier && integration_courier.is_active" slot="actions" @click="SavePya(false, true)">Desactivar</button>
        <button class="primary purple" v-if="integration_courier && integration_courier.is_active" slot="actions" @click="SavePyaSettings(true)">Guardar</button>
        <button class="primary purple" v-if="!integration_courier || !integration_courier.is_active" slot="actions" @click="SavePya(true, true)">Activar</button>
    </modal>

    <modal v-model="modalPyaIntegration" title="Configuración PedidosYa" dir="right" :modalClass="['fill', 'right md h100']">
        <div v-if="modalPyaIntegration" class="pa20">
            
            <div class="secondary-text mb15" v-if="!modalPyaIntegration.is_active">Debes ingresar las credenciales de PedidosYa</div>

            <input-field class="mb15"
            v-if="!modalPyaIntegration || !modalPyaIntegration.is_active"
            v-model="modalPyaIntegration.username"
            label="Usuario"
            placeholder="Usuario">
            </input-field>

            <input-field class="mb15"
            v-if="!modalPyaIntegration || !modalPyaIntegration.is_active"
            v-model="modalPyaIntegration.password"
            label="Contraseña"
            placeholder="Contraseña"
            type="password">
            </input-field>

            <input-field class="mb15"
            v-model="modalPyaIntegration.chain_id"
            label="Chain ID"
            placeholder="Chain ID">
            </input-field>

            <input-field class="mb15"
            v-model="modalPyaIntegration.vendor_id"
            label="Vendor ID"
            placeholder="Vendor ID">
            </input-field>

            <div v-if="modalPyaIntegration.is_active && modalPyaIntegration.in_service" class="flex align-center mb15">
                <div class="flex-fill">
                    <div class="bold">Estado</div>
                    <div :class="`${dictStatusPya[modalPyaIntegration.in_service].color}`">{{ modalPyaIntegration.in_service == 'CLOSED_UNTIL'? 'Cerrado hasta '+Util.Date(modalPyaIntegration.opening_time, 'HH:mm') : dictStatusPya[modalPyaIntegration.in_service].label }}</div>
                </div>
                <button class="secondary" :disabled="!modalPyaIntegration.changeable" @click="modalPyaIntegrationStatusService=Util.Copy({...modalPyaIntegration, futureStatus: modalPyaIntegration.in_service})">Editar</button>
            </div>

            <input-toggle class="mb15"
            v-if="modalPyaIntegration && modalPyaIntegration.is_active"
            v-model="modalPyaIntegration.implement_menu"
            label="Sincronización de menú"
            description="Se sobrescribirá el menú de PedidosYa con el menú de Influye">
            </input-toggle>
        </div>

        <button class="primary error-color" v-if="modalPyaIntegration && !modalPyaIntegration.is_active" slot="actions" @click="ClearPyaSettings()">Limpiar</button>
        <button class="primary error-color" v-if="modalPyaIntegration && modalPyaIntegration.is_active" slot="actions" @click="SavePya(false)">Desactivar</button>
        <button class="primary purple" v-if="modalPyaIntegration && modalPyaIntegration.is_active" slot="actions" @click="SavePyaSettings()">Guardar</button>
        <button class="primary purple" v-if="!modalPyaIntegration || !modalPyaIntegration.is_active" slot="actions" @click="SavePya(true)">Activar</button>
    </modal>

    <modal v-model="modalFacturacion" title="Datos de facturación" dir="right" :modalClass="['fill', 'right h100 md']">
        <div v-if="modalFacturacion" class="pa20">
            <input-field
            inputClass="primary mb15"
            v-model="modalFacturacion.rut"
            placeholder="RUT"
            label="RUT">
            </input-field>

            <input-field
            inputClass="primary mb15"
            v-model="modalFacturacion.name"
            placeholder="Razón Social"
            label="Razón social">
            </input-field>

            <input-field
            inputClass="primary mb15"
            v-model="modalFacturacion.email"
            placeholder="Email"
            label="Email">
            </input-field>

            <input-field
            inputClass="primary mb15"
            v-model="modalFacturacion.address"
            placeholder="Dirección"
            label="Dirección">
            </input-field>

            <input-field
            inputClass="primary mb15"
            v-model="modalFacturacion.city"
            placeholder="Ciudad"
            label="Ciudad">
            </input-field>

            <input-field
            inputClass="primary mb15"
            v-model="modalFacturacion.commune"
            placeholder="Comuna"
            label="Comuna">
            </input-field>

            <input-field
            inputClass="primary mb15"
            v-model="modalFacturacion.line_business"
            placeholder="Giro"
            label="Giro del negocio">
            </input-field>
        </div>
        <button class="primary error-color" slot="actions" v-if="facturacion && facturacion.rut" @click="Confirm({
                title: `Se borrarán los datos de facturación`,
                text: 'Confirmar',
                class: 'selected-color',
                function: () => {DeleteDataFacturacion()}
            })">Borrar</button>
        <button class="primary purple" slot="actions" @click="SaveDataFacturacion()">Guardar</button>
    </modal>

    <modal v-model="modalHideMethodsGhostClose" dir="center" modalClass="sm" title="Métodos de Pago en Cierre Fantasma">
        <div class="pa20" v-if="modalHideMethodsGhostClose">
            <div class="">
                <div :class="`well mb10`"
                    v-for="(value, key) in modalHideMethodsGhostClose"
                    :key="key">
                    <div class="fill flex align-center">
                        <div class="flex flex-fill column">
                            <div class="flex flex-fill align-center">
                                <label><input type="checkbox" v-model="value.hide"><div class="checkmark reverse"></div></label>
                                <div class="bold">{{ Util.PayMethod(key)}}</div>
                            </div>
                            <label v-if="!value.hide" class="ml35 align-center">
                                <input type="checkbox" v-model="value.declaration">
                                <div>
                                    <div class="secondary-text">Monto ingresados son con propina incluida</div>
                                </div> <div class="checkmark sm"></div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button slot="actions" v-if="modalHideMethodsGhostClose" class="primary purple" @click="SaveHideMethodsGhostClose()">Aceptar</button>
    </modal>

    <!-- Modal para seleccionar un archivo KML -->
    <modal v-model="modalImportMaps" dir="center" modalClass="sm" title="Importar Zonas">
        <div class="secondary-text pa20">Seleccione un archivo KML con la zona delimitada o un archivo JSON con las zonas de reparto.</div>
    
        <button-file accept=".kml,.json" slot="actions"
        :type="null" v-if="modalImportMaps"
        @FileSelected="file => {$set(modalImportMaps, 'file', file)}">
            <button :class="`secondary ${modalImportMaps.file ? '' : ''}`">{{modalImportMaps.file ? modalImportMaps.file.name : 'Seleccionar Archivo'}}</button>
        </button-file>
        <button slot="actions" class="primary purple" @click="ImportMaps()">Importar</button>
    </modal>

    <!-- Modal zona -->
    <modal v-model="modalZone" dir="center" modalClass="sm" title="Zona">
        <div class="section" v-if="modalZone">

            <input-field v-model="modalZone.label" class="mb15"
            label="Nombre"
            placeholder="(Opcional)">
            </input-field>

            <input-field class="mb15"
            v-model="modalZone.radio"
            label="Radio en Kilómetros"
            placeholder="(Opcional)"
            type="float+"
            suffix=" km">
            </input-field>

            <input-field class="mb15"
            v-model="modalZone.cost"
            label="Costo de Reparto"
            type="int+"
            prefix="$">
            </input-field>

            <label>
                <input type="checkbox" v-model="modalZone.disabled"><div>Deshabilitado (Pedidos Online)</div> <div class="checkmark"></div>
            </label>

        </div>
        
        <button slot="actions" v-if="modalZone" class="primary purple" @click="AddZone()">{{modalZone.edit!==undefined ? 'Editar Zona' : 'Agregar Zona'}}</button>
        
    </modal>

    <modal v-model="modalGoogleMapsApi" dir="center" modalClass="sm" title="Llave API Google Maps">
        <div class="pa20" v-if="modalGoogleMapsApi">
            <!-- <button class="secondary" @click="Util.Open(`https://maps.googleapis.com/maps/api/geocode/json?address=chile&key=${config.google_maps_api_key}`)">Probar Llave</button> -->
            <input-field 
            label="Llave API"
            v-model="modalGoogleMapsApi.key">
            </input-field>
        </div>
        <button v-if="config.google_maps_api_key" slot="actions" class="primary error-color" @click="config.google_maps_api_key = null; modalGoogleMapsApi = null">Eliminar</button>
        <button slot="actions" class="primary purple" @click="SaveGoogleMapsApi()">Aceptar</button>
    </modal>

</div>
</div>       
</template>

<script>
export default {
    data() {
        return {
            local: null,
            config: null,
            integration_courier: null,
            integration_pya: null,
            integration_ue: null,
            facturacion: null,
            delivery: null,
            modalPayMethods: null,
            modalProfile: null,
            modalBank: null,
            modalTransbank: null,
            modalRule : null,
            currentPolygon: null,
            modalImportMaps: null,
            dragList : [],
            modalZone: null,
            modalPya: null,
            modalPyaIntegration: null,
            modalFacturacion: null,
            modalPyaIntegrationStatusService: null,
            optionsReduceInventoryCompleted: [{text: 'Reducir al completar el pedido', value: true}, {text: 'Reducir al ingresar el pedido', value: false}],
            optionsDefaultSale: [{text: 'Servir', value: 'SERVE'}, {text: 'Llevar', value: 'TAKEAWAY'}, {text: 'Delivery', value: 'DELIVERY'}, {text: 'Se debe seleccionar en cada pedido', value: 'NO_DEFAULT'}],
            optionsDefaultPaid: [{text: 'Pago al ingresar pedido', value: 'CREATED'}, {text: 'Pago al completar pedido', value: 'COMPLETED'}, {text: 'Elegir en cada caso', value: 'CUSTOM'}],
            timezoneItems: [{text: 'Chile - Santiago', value: 'America/Santiago'}, {text: 'Chile - Punta Arenas', value: 'America/Punta_Arenas'}],
            transbankDebit: null,
            transbankCredit: null,
            modalGetnet: null,
            modalMercadoPago: null,
            dictStatusPya: {
                CLOSED_UNTIL: { label: 'Cerrado hasta --:--', color: 'cred' },
                CLOSED: { label: 'Cerrado', color: 'cred' },
                //INACTIVE: { label: 'Inactivo', color: 'cred' }, Consultar eso a miguel, porque la api de pedidos ya no lo permite, a pesar de que según la documentación si
                UNKNOWN: { label: 'Desconocido', color: 'cyellow' },
                OPEN: { label: 'Abierto', color: 'cgreen' },
                CLOSED_TODAY: { label: 'Cerrado por hoy', color: 'cred' },
            },
            franchise: null,
            modalUE: null,
            modalStatusUe: null,
            modalSetBussyMode: null,
            optionsDefaultShowMenuDescription: [{text: 'No mostrar descripción', value: 'NONE'}, {text: 'Mostrar descripción', value: 'DESCRIPTION'}, {text: 'Mostrar descripción impresa', value: 'PRINTER'}],
            // Mismos `value` que itemsOrderBy en OrdersView.vue; el primero deja el sort por defecto del cliente.
            optionsDefaultOrdersSort: [
                { text: 'No fijar', value: 'NONE' },
                { text: 'Ordenar manualmente', value: 'CUSTOM' },
                { text: 'Ordenar nuevos primero', value: 'TICKET' },
                { text: 'Ordenar nuevos al final', value: 'TICKET_ASC' },
                { text: 'Ordenar próximos a entregar', value: 'SCHEDULED' },
                { text: 'Ordenar por total', value: 'TOTAL' },
            ],
            hideMethodsGhostClose : [],
            modalHideMethodsGhostClose : null,
            modalNewBrand: null,
            brands: [],
            modalSchedule: null,
            dictDays: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
            modalTerminal : null,
            modalGoogleMapsApi: null,
        }
    },
    mounted() {
        this.Loading();
        axios.get(`/local/${this.Local.id}/general`).then((res) => {
            this.local = res.data.local;
            let config  = res.data.config;
            config.show_cancelled_orders = config.cancelled_transactions_time > 0;
            config.hide_kitchen_activation_time = config.kitchen_activation_time > 0;
            this.config = config;
            this.integration_courier = res.data.pya;
            this.integration_pya = res.data.pya_integration;
            this.integration_ue = res.data.integration_ue;
            this.facturacion = res.data.facturacion;
            this.franchise = res.data.franchise;
            this.hideMethodsGhostClose = !this.config.hide_methods_ghost_close ? [] : this.config.hide_methods_ghost_close;
            this.ghostCloseTipDeclarations = !this.config.tip_declarations ? [] : this.config.tip_declarations;
            this.config.orders_ticket_sort = !this.config.orders_ticket_sort ? "NONE" : this.config.orders_ticket_sort;

            let auxArrayMethods = []
            if(this.config.payment_methods_order.length == 0) this.config.payment_methods_order = ['CASH','BANK_DEPOSIT','ONLINE', 'ONLINE_GETNET', 'ONLINE_MERCADO_PAGO'];

            auxArrayMethods = [{title:'CASH'}, {title:'BANK_DEPOSIT'}, {title:'ONLINE'}, {title:'ONLINE_GETNET'}, {title:'ONLINE_MERCADO_PAGO'}];

            this.config.payment_methods.forEach(element => {
                let exist = auxArrayMethods.some(o => o.title == element.title)
                auxArrayMethods.push(element)
                if(!exist && this.config.payment_methods_order.length == 0){
                    this.config.payment_methods_order.push(element.title)
                } 
                if(element.transbank_debit) this.transbankDebit = element.title;
                if(element.transbank_credit) this.transbankCredit = element.title;
            });

            let indexMap = {};
            this.config.payment_methods_order.forEach((obj, index) => {
                indexMap[obj] = index;
            });

            let sortedMethods = auxArrayMethods.sort((x, y) => indexMap[x.title] - indexMap[y.title]);

            this.dragList = sortedMethods;

            let copy = Util.Copy(this.hideMethodsGhostClose);
            let methods = Util.Copy(this.dragList);
            let toHide = {};

            methods.forEach(method => {
                if(copy[method.title] != undefined) toHide[method.title] = copy[method.title];
                else toHide[method.title] = {hide:false, declaration: false};
            });

            this.hideMethodsGhostClose = toHide;

            if(Array.isArray(res.data.delivery.bank_settings)) res.data.delivery.bank_settings = {};
            this.delivery = res.data.delivery;
            let zones = Util.Copy(this.delivery.zones)

            this.delivery.zones = zones.map((zone, index) => {
                if(!zone.label || zone.label.trim() == '') zone.label = `Zona ${index+1}`;
                return zone;
            });

            this.brands.push(...res.data.brands);

            if(this.Local.modules.module_ue && this.integration_ue && this.integration_ue.is_active) this.LoadStatusUE();
            this.brands.forEach(brand => {
                if(brand.integration_ue && brand.integration_ue.is_active) this.LoadStatusUE(brand.integration_ue);
            });
            this.Response(res);
        }).catch(err => {
            this.Response(err);
        });
    },
    methods: {
        EditPendingPayments(){
            let search = this.config.payment_methods.find(element => element.title == this.modalPayMethods.title)            
            this.$set(search, 'pending_payment', !!this.modalPayMethods.pending_payment);
            this.$set(search, 'payment_data',  this.modalPayMethods.payment_data);
            this.$set(search, 'hide_ghost_close',  this.modalPayMethods.hide_ghost_close); 
            this.modalPayMethods = null
        },
        OpenModalPayMethods(method, index) {
            if(method.title){
                this.modalPayMethods={title: method.title, pending_payment: !!method.pending_payment, edit: true, index: index, payment_data : method.payment_data, hide_ghost_close : method.hide_ghost_close}
            } 
        },
        SaveProfile() {
            this.$root.$emit('Loading');

            if(this.modalProfile.type == 'BRAND') {
                this.UpdateBrand(this.modalProfile)
                return;
            }

            axios.patch('/local/' + this.local.id, this.modalProfile).then((res) => {
                this.local = res.data;
                this.modalProfile = null;
                this.Info('Perfil guardado');
            }).catch((err) => {
                this.$root.$emit('Response', err);
            });
        },
        Save() {
            if(this.config.active_kitchen_delay){
                if(isNaN(this.config.kitchen_late_time) && isNaN(this.config.kitchen_very_late_time)) return this.Info("Debe ingresar tiempo en 'atrasado' o 'muy atrasado' o en ambos ")
                if(this.config.kitchen_late_time === 0 && this.config.kitchen_very_late_time === 0) return this.Info("'Atrasado' o 'Muy atrasado' debe ser mayor a 0")
                if((this.config.kitchen_late_time === 0 && isNaN(this.config.kitchen_very_late_time)) || (this.config.kitchen_very_late_time === 0 && isNaN(this.config.kitchen_late_time))) return this.Info("Debe ingresar un valor válido")
            }

            if(!this.config.accept_serve && !this.config.accept_takeaway && !this.config.accept_delivery) return this.Info('Se debe aceptar por lo menos 1 tipo de pedido');
            if(!this.config.accept_serve && this.config.default_sale == 'SERVE') return this.Info('Se debe aceptar pedidos para Servir para marcarlo por defecto');
            if(!this.config.accept_takeaway && this.config.default_sale == 'TAKEAWAY') return this.Info('Se debe aceptar pedidos para Llevar para marcarlo por defecto');
            if(!this.config.accept_delivery && this.config.default_sale == 'DELIVERY') return this.Info('Se debe aceptar pedidos para Delivery para marcarlo por defecto');

            this.config.payment_methods.forEach(method => {
                delete method.transbank_debit;
                delete method.transbank_credit;
            });
            if(this.config.transbank_pos)
            {
                if(!this.config.transbank_pos_code || this.config.transbank_pos_code.length < 6) return this.Info('Se debe ingresar una contraseña para la Transbank POS Integrado (mínimo 6 caracteres)');
            }
            let tbkDebit = this.config.payment_methods.find(el => el.title == this.transbankDebit);
            //if(!tbkDebit) return this.Info('Se debe asociar un método de pago a Transbank Crédito');
            if(tbkDebit) tbkDebit.transbank_debit = true;
            let tbkCredit = this.config.payment_methods.find(el => el.title == this.transbankCredit);
            //if(!tbkCredit) return this.Info('Se debe asociar un método de pago a Transbank Crédito');
            if(tbkCredit) tbkCredit.transbank_credit = true;

            this.config.zones = this.delivery.zones;
            let newOrder = []
            for (let index = 0; index < this.dragList.length; index++) {
                const element = this.dragList[index];
                newOrder.push(element.title)
            }

            this.config.hide_methods_ghost_close = this.hideMethodsGhostClose; 
            this.config.payment_methods_order = newOrder
            this.config.rules = this.delivery.rules;

            if(!this.config.show_cancelled_orders) this.config.cancelled_transactions_time = 0;
            if(!this.config.hide_kitchen_activation_time) this.config.kitchen_activation_time = 0;

            this.Loading();
            axios.patch(`/settings/${this.Local.id}/v2`, this.config).then(res => {
                this.$emit('OnSettingsSaved');
                this.Info('Ajustes guardados');
            }).catch(err => {
                this.Response(err);
            });
        },
        UpdateLocation(latlng)
        {
            this.$set(this.modalProfile, 'latitude', latlng.lat);
            this.$set(this.modalProfile, 'longitude', latlng.lng);
        },
        AddPaymentMethod()
        {
            if(!this.modalPayMethods.title) return this.Info('Datos inválidos');
            if(this.config.payment_methods.filter(a => { return a.title === this.modalPayMethods.title}).length > 0) return this.Info('El método de pago ya existe');
            this.config.payment_methods.push({title: this.modalPayMethods.title, pending_payment: !!this.modalPayMethods.pending_payment, payment_data : this.modalPayMethods.payment_data, hide_ghost_close: this.modalPayMethods.hide_ghost_close});
            this.dragList.push({title: this.modalPayMethods.title, pending_payment: !!this.modalPayMethods.pending_payment, payment_data : this.modalPayMethods.payment_data, hide_ghost_close: this.modalPayMethods.hide_ghost_close}); 
            this.hideMethodsGhostClose[this.modalPayMethods.title] = {hide : false, declaration: false};
            this.modalPayMethods = null;
        },
        DeletePaymentMethod(index){
            let index_payment = this.config.payment_methods.findIndex(element => element.title == this.dragList[index].title);
            let index_hide = Object.keys(this.hideMethodsGhostClose).find(element => element == this.dragList[index].title);
            this.config.payment_methods.splice(index_payment, 1);
            this.dragList.splice(index, 1);
            this.$delete(this.hideMethodsGhostClose, index_hide);
        },
        SaveBankData()
        {
            this.Loading();
            axios.patch(`/settings/${this.local.id}/bank`, {bank_settings: this.modalBank}).then(res => {
                this.Response(res);
                this.$set(this.delivery, 'bank_settings', this.modalBank);
                this.modalBank = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        SaveTransbankID(isDelete = false)
        {
            this.Loading();
            axios.patch(`/settings/${this.local.id}/transbank`, {transbank: this.modalTransbank.transbank_commerce, delete: isDelete}).then(res => {
                this.Response(res);
                this.$set(this.delivery, 'transbank_commerce', res.data.id);
                if(!res.data.id) this.$set(this.config, 'accepts_online_payment', false);
                this.modalTransbank = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        SaveGetnetSetting(isDelete = false){
            this.Loading();
            let request = {
                getnet: this.modalGetnet.getnet_commerce, 
                secretKey: this.modalGetnet.getnet_commerce_secretkey,
                delete: isDelete
            };

            axios.patch(`/settings/${this.local.id}/getnet`, request).then(({data}) => {
                this.Response(data);
                this.$set(this.delivery, 'getnet_commerce', data.getnet_commerce);
                this.$set(this.delivery, 'getnet_commerce_secretkey', data.getnet_commerce_secretkey);
                if(!data.getnet_commerce) this.$set(this.config, 'accepts_online_payment_getnet', false);
                this.modalGetnet = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        SaveMercadoPagoSetting(isDelete = false){
            this.Loading();
            if(this.modalMercadoPago.mercado_pago_access_token && !this.modalMercadoPago.mercado_pago_webhook_secret) return this.Info("Debes ingresar la Clave Secreta del Webhook para un correcto funcionamiento de Mercado Pago");
            let data = {
                mercado_pago_access_token: this.modalMercadoPago.mercado_pago_access_token,
                mercado_pago_webhook_secret: this.modalMercadoPago.mercado_pago_webhook_secret,
                delete: isDelete,
            };

            axios.patch(`/settings/${this.local.id}/mercadopago`, data).then(({data}) => {
                this.Response(data);
                this.$set(this.delivery, 'mercado_pago_access_token', data.mercado_pago_access_token);
                this.$set(this.delivery, 'mercado_pago_webhook_secret', data.mercado_pago_webhook_secret);
                this.$set(this.delivery, 'mercado_pago_user_id', data.mercado_pago_user_id);
                if(!data.mercado_pago_access_token) this.$set(this.config, 'accepts_online_payment_mercado_pago', false);
                this.modalMercadoPago = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        RemoveRule(index) {
            this.delivery.rules.splice(index, 1);
        },
        SelectPolygon(index) {
            this.currentPolygon = index;
            var bg = [];
            for(var i = 0; i < this.delivery.zones.length; i++)
                if(i !== index) bg.push(this.delivery.zones[i].polygon);
            this.$nextTick(() => {
                this.$refs.map.SetPolygon(this.delivery.zones[index].polygon, bg);
            });
            
        },
        RemovePolygon(index) {
            let deleted = this.delivery.zones.splice(index, 1);
     
            if (this.delivery.rules.length) {
                this.delivery.rules.forEach(rule => {
                    if (rule.delivery_zones && Array.isArray(rule.delivery_zones)) {
                        let index = rule.delivery_zones.findIndex(
                            zone => zone === deleted[0].label
                        );
                        if (index !== -1) {
                            rule.delivery_zones.splice(index, 1);
                        }
                    }
                });
            }

            if(!this.delivery.zones.length)
            {
                this.currentPolygon = null;
                this.$refs.map.SetPolygon([]);
            }
            else
            {
                this.SelectPolygon(index > 0 ? (index-1) : 0);
            }
        },
        UpdatePolygon(polygon)
        {
            if(this.currentPolygon !== null)
            {
                this.$set(this.delivery.zones[this.currentPolygon], 'polygon', polygon);
            }
            console.log(polygon)
        },
        AddZone() {

            var polygon = [];    
            var radio = null;
            if(this.modalZone.radio && !isNaN(this.modalZone.radio))
            {
                var center = {lat: Number(this.local.latitude), lng: Number(this.local.longitude)};
                radio = parseFloat(this.modalZone.radio);

                var R = 6371;
                var pi = Math.PI;

                var lat  = (center.lat * pi) / 180;
                console.log('lat ' + lat);
                var lng  = (center.lng * pi) / 180;
                var d = radio / R;

                for(var angle = 0; angle < 360; angle+=15)
                {
                    var brng = angle * pi / 180;
                    console.log('brng ' + brng);

                    var pLat = Math.asin(Math.sin(lat)*Math.cos(d) + Math.cos(lat)*Math.sin(d)*Math.cos(brng));
                    console.log('pLat ' + pLat);
                    var pLng = ((lng + Math.atan2(Math.sin(brng)*Math.sin(d)*Math.cos(lat), Math.cos(d)-Math.sin(lat)*Math.sin(pLat))) * 180) / pi;
                    pLat = (pLat * 180) / pi;

                    polygon.push({
                        lat: pLat,
                        lng: pLng
                    });
                }
            }

            if(radio && !this.modalZone.label) this.modalZone.label = `${radio} Km`;
            if(this.modalZone.label == '') this.modalZone.label = `Zona ${this.delivery.zones.length == 0 ? 1 : (this.delivery.zones.length+1)}`;
            if(!this.modalZone.cost) this.modalZone.cost = 0;
            if(this.modalZone.edit !== undefined)
            {
                if (this.delivery.rules.length) {
                    this.delivery.rules.forEach(rule => {
                        if (rule.delivery_zones && Array.isArray(rule.delivery_zones)) {
                            let index = rule.delivery_zones.findIndex(
                                zone => zone === this.modalZone.old_label
                            );
                            if (index !== -1) {
                                rule.delivery_zones[index] = this.modalZone.label;
                            }
                        }
                    });
                }

                if(radio) this.modalZone.polygon = polygon;
                this.$set(this.delivery.zones, this.modalZone.edit, this.modalZone);
                this.SelectPolygon(this.modalZone.edit);
            }
            else
            {
                this.modalZone.polygon = polygon;
                this.delivery.zones.push(this.modalZone);
                this.SelectPolygon(this.delivery.zones.length-1);
            }
            this.modalZone = null;
        },
        AddRule() {
            if(this.modalRule.label == '') this.modalRule.label = `Regla ${this.delivery.rules.length == 0 ? 1 : (this.delivery.rules.length+1)}`;     
            if(this.modalRule.edit !== undefined)
            {
                this.$set(this.delivery.rules, this.modalRule.edit, this.modalRule);
            }
            else
            {
                this.delivery.rules.push(this.modalRule);
            }
            this.modalRule = null;
        },
        ImportMaps()
        {
            const reader = new FileReader();

            reader.onload = (e) => {
                console.log(e.target.result);
                if(this.modalImportMaps.file.name.indexOf('.json') > -1)
                {
                    let json = JSON.parse(e.target.result);
                    if(!json || !Array.isArray(json) || !json.length) return this.Info('Archivo inválido');
                    let zones = [];
                    for(let i = 0; i < json.length; i++)
                    {
                        let zone = json[i];
                        if(!zone.polygon || !Array.isArray(zone.polygon)) return this.Info('Archivo inválido');
                        let polygon = [];
                        zone.polygon.forEach(point => {
                            if(point.lat && !isNaN(point.lat) && point.lng && !isNaN(point.lng)) polygon.push({lat: point.lat, lng: point.lng});
                        });
                        this.delivery.zones.push({
                            label: typeof zone.label == 'string' ? zone.label : null,
                            radio: typeof zone.radio == 'number' ? zone.radio : null,
                            cost: typeof zone.cost == 'number' ? parseInt(zone.cost) : 0,
                            polygon: polygon,
                        });
                    }
                }
                else //KML
                {
                    var stringXML = e.target.result;
                    var domParser = new DOMParser();
                    var xmlDocument = domParser.parseFromString(stringXML, "text/xml");

                    console.log(xmlDocument);

                    var placemarks = xmlDocument.getElementsByTagName('Placemark');
                    for(var i = 0; i < placemarks.length; i++)
                    {
                        var placemark = placemarks[i];
                        var polygon = placemark.getElementsByTagName('Polygon');
                        if(polygon && polygon.length)
                        {
                            var names = placemark.getElementsByTagName('name');
                            var name = '';
                            if(names && names.length) name = names[0].textContent;
                            console.log(name);
                            
                            var coordinates = polygon[0].getElementsByTagName('coordinates');
                            if(coordinates && coordinates.length) coordinates = coordinates[0].textContent.trim();
                            else coordinates = null;
                            console.log(coordinates);

                            if(coordinates)
                            {
                                var poly = [];
                                var coords = coordinates.split(' ');
                                var pointsMap = {};
                                coords.forEach(point => {
                                    if(point)
                                    {
                                        var xyz = point.split(',');
                                        if(xyz.length >= 2)
                                        {
                                            var lat = parseFloat(xyz[1]);
                                            var lon = parseFloat(xyz[0]);
                                            if(!isNaN(lat) && !isNaN(lon))
                                            {
                                                if(!pointsMap[lat+','+lon])
                                                {
                                                    poly.push({lat: lat, lng: lon});
                                                    pointsMap[lat+','+lon] = true;
                                                }
                                            }
                                        }
                                    }
                                });
                                if(poly.length)
                                {
                                    this.delivery.zones.push({
                                        cost: 0, 
                                        polygon: poly,
                                        label: name ? name : 'Zona importada'
                                    });
                                    
                                }
                            }

                        }

                        

                    };
                }

                this.modalImportMaps = false;
                this.SelectPolygon(this.delivery.zones.length-1);
            };
            reader.readAsText(this.modalImportMaps.file);
        },
        ResetTicketNumber() {
            this.Loading();
            axios.patch(`/local/${this.Local.id}/ticket/reset`).then(res => {
                this.Info('Enúmeración de pedidos reiniciada');
            }).catch(err => {
                this.Response(err);
            });
        },
        SavePya(futureStatus, courier = false) {
            if(!courier && !this.modalPyaIntegration) return this.Info('Debes ingresar las credenciales de PedidosYa');

            this.Loading();
            const idLocal = courier? this.Local.id : this.modalPyaIntegration.id; 
            const modalData = courier ? this.modalPya : this.modalPyaIntegration;
            
            const url = `/pya/settings/${idLocal}/${courier ? '' : 'integration/'}${futureStatus ? 'enable' : 'disable'}`;
            axios.patch(url, modalData)
            .then(({ data }) => {
                if (courier) {
                    this.integration_courier = data;
                    this.modalPya = data.is_active ? this.Util.Copy(data) : null;
                } else {
                    this.UpdatePyaIntegration(data);
                    this.modalPyaIntegration = data.is_active ? this.Util.Copy(data) : null;
                }
                
                this.Info(`Integración ${data.is_active ? 'activada' : 'desactivada'}`);
            })
            .catch(err => {
                this.Response(err);
            });
        },
        SavePyaSettings(courier = false){
            this.Loading();
            let idLocal = null;
            let modalData = null;
            if(courier) {
                modalData = this.modalPya;
                idLocal = this.Local.id;
            } else {
                modalData = this.modalPyaIntegration;
                idLocal = this.modalPyaIntegration.id;
            }

            axios.patch(`/pya/settings/${idLocal}${courier ? '' : '/integration'}`, modalData).then( ({data}) => {
                if(courier){
                    this.integration_courier = data;
                    this.modalPya = this.Util.Copy(data);
                }else{
                    this.UpdatePyaIntegration(data);
                    this.modalPyaIntegration = this.Util.Copy(data);
                }
                this.Info('Datos guardados');
            })
            .catch(err => {
                this.Response(err);
            });
        },
        UpdatePyaIntegration(data) {
            const brandIndex = this.brands.findIndex(brand => brand.id == data.id);

            if (brandIndex !== -1) {
                this.$set(this.brands[brandIndex], 'integration_pya', data);
            } else {
                this.integration_pya = data;
            }
        },
        MandatoryFunctionsUE() {
            this.Loading();
            const localMain = this.modalUE.id;
            axios.post(`/uber_eats/mandatory_functions/${localMain}`)
            .then(({ data }) => {
                if(!data.url)
                    return this.Info('No se pudo obtener la URL de autorización.');

                window.open(data.url, '_blank');
                this.Response(data);
            })
            .catch(err => {
                this.Response(err);
            });
        },
        UnlinkUE() {
            const localMain = this.modalUE.id;
            this.Loading();
            axios.delete(`/uber_eats/settings/${localMain}/integration`)
            .then(({ data }) => {
                const brandIndex = this.brands.findIndex(brand => brand.id == data.id);
                if (brandIndex !== -1) {
                    this.$set(this.brands[brandIndex], 'integration_ue', data);
                } else {
                    this.integration_ue = data;
                }
                this.OpenModalUE(data);
                this.Info('Sucursal deshomologada de Uber Eats');
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    return this.Info(err.response.data.message);
                }
                this.Response(err);
            });
        },
        SaveUE(futureStatus){
            if(!this.modalUE) return;
            if(!this.modalUE.id_store) return this.Info('Es necesario dar permisos a Influye para poder activar la integración con Uber Eats');
            this.Loading();
            const localMain = this.modalUE.id;
            const url = `/uber_eats/settings/active/${localMain}`;
            axios.patch(url, {data: {futureStatus, ...this.modalUE}})
            .then(({ data }) => {
                const brandIndex = this.brands.findIndex(brand => brand.id == data.id);

                if (brandIndex !== -1) {
                    this.$set(this.brands[brandIndex], 'integration_ue', data);
                } else {
                    this.integration_ue = data;
                }

                this.modalUE = data.is_active
                    ? this.OpenModalUE(data)
                    : null;

                this.Info(`Integración ${data.is_active ? 'activada' : 'desactivada'}`);
            })
            .catch(err => {
                this.Response(err);
            });
        },
        SaveUESettings(){
            if(!this.modalUE.prep_time) return this.Info('El tiempo de preparación es obligatorio');
            
            if (this.modalUE.prep_time !== this.modalUE.original_time) {
                const [hours, minutes] = this.modalUE.prep_time.split(":").map(Number);
                let timeToSeconds = (hours * 3600) + (minutes * 60);

                if(timeToSeconds < 600 || timeToSeconds > 10800) 
                    return this.Info('El tiempo de preparación debe estar entre 10 minutos y 3 horas');
            }

            const localMain = this.modalUE.id;

            this.Loading();

            let status = this.modalUE.status;
            let is_offline_until = this.modalUE.is_offline_until;

            axios.patch(`/uber_eats/settings/${localMain}`, this.modalUE).then( ({data}) => {
                const brandIndex = this.brands.findIndex(brand => brand.id == data.id);

                if (brandIndex !== -1) {
                    this.$set(this.brands[brandIndex], 'integration_ue', {...data, status, is_offline_until});
                } else {
                    this.integration_ue = {...data, status, is_offline_until};
                }

                const totalMinutes = Math.floor(data.prep_time / 60);
                const hours = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
                const minutes = String(totalMinutes % 60).padStart(2, "0");

                data.prep_time = `${hours}:${minutes}`;

                this.modalUE = this.Util.Copy({...data, status, is_offline_until});
                return this.Info('Datos guardados');
            })
            .catch(err => {
                this.Response(err);
            });
        },
        ClearPyaSettings() {
            const localMain = this.modalPyaIntegration.id;
            this.Loading();
            axios.get(`/pya/settings/${localMain}/integration/clear`).then( ({data}) => {
                const brandIndex = this.brands.findIndex(brand => brand.id == data.settings.id);

                if (brandIndex !== -1) {
                    this.$set(this.brands[brandIndex], 'integration_pya', data.settings);
                } else {
                    this.integration_pya = data.settings;
                }

                this.modalPyaIntegration = null;
                this.Info('Datos de integración limpiados');
            })
            .catch(err => {
                this.Response(err);
            });
        },
        SaveDataFacturacion(){
            const rutRegex = /^\d{1,2}\.\d{3}\.\d{3}[-][0-9kK]{1}$/;

            if(!this.modalFacturacion.rut) return this.Info('RUT es obligatorio');
            if(!this.modalFacturacion.name) return this.Info('Razón social es obligatorio');
            if(!this.modalFacturacion.email) return this.Info('Email es obligatorio');
            if(!this.modalFacturacion.address) return this.Info('Dirección es obligatorio');
            if(!this.modalFacturacion.city) return this.Info('Ciudad es obligatorio');
            if(!this.modalFacturacion.commune) return this.Info('Comuna es obligatorio');
            if(!this.modalFacturacion.line_business) return this.Info('Giro es obligatorio');

            if(!this.modalFacturacion.rut.includes('-')) this.modalFacturacion.rut = Util.Rut(this.modalFacturacion.rut);
            if(!rutRegex.test(this.modalFacturacion.rut)) return this.Info('Rut inválido');

            this.Loading();
            axios.post(`/sii/settings/facturacion/${this.Local.id}/create`, this.modalFacturacion)
            .then( ({data}) => {
                if(data.status){
                    this.facturacion = data.settings_facturacion;
                    this.modalFacturacion = null;
                }
                this.Info(data.message);
                this.Response(data);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        DeleteDataFacturacion(){
            this.Loading();
            axios.get(`/sii/settings/facturacion/${this.Local.id}/clean`)
            .then( ({data}) => {
                if(data.status){
                    this.facturacion = {};
                    this.modalFacturacion = null;
                }
                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        UpdateServicePya(config){
            const localMain = this.modalPyaIntegrationStatusService.id;

            this.Loading();
            let request = {futureStatus: config.futureStatus};
            // CLOSED_TODAY
            if(config.futureStatus == 'CLOSED_UNTIL'){
                let currentDate = new Date();

                let hours = currentDate.getHours() < 10 ? '0' + currentDate.getHours() : currentDate.getHours();
                let minutes = currentDate.getMinutes() < 10? '0' + currentDate.getMinutes() : currentDate.getMinutes();

                let currentTime = this.Util.TimeToMinutes(`${hours}:${minutes}`);
                let futureTime = this.Util.TimeToMinutes(config.closingMinutes);

                let differenceInMinutes = futureTime - currentTime;

                if (differenceInMinutes <= 0) return this.Info('La hora no puede ser inferior o igual a la actual');

                request.closingMinutes = differenceInMinutes;
                request.futureTime = config.closingMinutes;
            }

            axios.post(`/pya/settings/${localMain}/service`, request)
            .then( ({data}) => {
                if(data.status) {
                    const brandIndex = this.brands.findIndex(brand => brand.id == localMain);

                    if (brandIndex !== -1) {
                        this.$set(this.brands[brandIndex].integration_pya, 'in_service', config.futureStatus);
                    } else {
                        this.integration_pya.in_service = config.futureStatus;
                    }
                    
                    if(config.futureStatus == 'CLOSED_UNTIL' && data.opening_time) {
                        if (brandIndex !== -1) {
                            this.$set(this.brands[brandIndex].integration_pya, 'opening_time', data.opening_time);
                        } else {
                            this.integration_pya.opening_time = data.opening_time;
                        }
                    }
                    if(this.modalPyaIntegration && this.modalPyaIntegration.id == localMain) {
                        this.$set(this.modalPyaIntegration, 'in_service', config.futureStatus);
                        if(data.opening_time) this.$set(this.modalPyaIntegration, 'opening_time', data.opening_time);
                    }
                    this.modalPyaIntegrationStatusService = null;
                }
                this.Info(data.message)
                this.Response(data);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        ExportZones() 
        {
            console.log(this.delivery.zones);
            const jsonStr = JSON.stringify(this.delivery.zones, null, 2); // pretty print with 2 spaces
            const blob = new Blob([jsonStr], { type: 'application/json' });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'zonas_de_reparto.json';

            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        OpenModalUE(data){
            const totalMinutes = Math.floor(data.prep_time / 60);
            const hours = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
            const minutes = String(totalMinutes % 60).padStart(2, "0");

            if(data.is_active) this.LoadStatusUE(data);
            
            const modalData = this.Util.Copy({
                ...data,
                prep_time: `${hours}:${minutes}`,
                original_time: `${hours}:${minutes}`
            });
            
            this.modalUE = modalData;
            return this.modalUE;
        },
        LoadStatusUE(integration = this.integration_ue){
            this.Loading();
            return axios.get(`/uber_eats/settings/${integration.id || this.Local.id}/status`)
            .catch(() => ({data: null}))
            .then(({data}) => {
                const status = data && ['ONLINE', 'OFFLINE'].includes(data.status) ? data.status : null;
                const is_offline_until = status == 'OFFLINE' ? data.is_offline_until : null;

                this.$set(integration, 'status', status);
                this.$set(integration, 'is_offline_until', is_offline_until);
                if(this.modalUE && this.modalUE.id == integration.id) {
                    this.$set(this.modalUE, 'status', status);
                    this.$set(this.modalUE, 'is_offline_until', is_offline_until);
                }
                this.Response({});
            });
        },
        UpdateStatusUE(){
            const idLocalMain = this.modalStatusUe.id? this.modalStatusUe.id : this.Local.id;
            function ddmmyyyyToISO(str) {
                const [fecha, hora] = str.split(' ');
                const [dia, mes, anio] = fecha.split('/');

                const isoLike = `${anio}-${mes}-${dia}T${hora || '00:00'}`;

                const d = new Date(isoLike);
                return isNaN(d.getTime()) ? null : d.toISOString();
            }

            let payload = {
                status: this.modalStatusUe.status,
                reason: this.modalStatusUe.reason || undefined
            }

            if (this.modalStatusUe.is_offline_until && this.modalStatusUe.is_offline_until !== 'ONLINE') {
                const iso = ddmmyyyyToISO(this.modalStatusUe.is_offline_until);
                if (iso) payload.is_offline_until = iso;
            }

            axios.post(`/uber_eats/settings/${idLocalMain}/status`, payload).then(({data}) => {
                if(!data.status) return this.modalStatusUe = null;

                const brandIndex = this.brands.findIndex(brand => brand.id == idLocalMain);

                if (brandIndex !== -1) {
                    this.$set(this.brands[brandIndex].integration_ue, 'status', data.status);
                    this.$set(this.brands[brandIndex].integration_ue, 'is_offline_until', data.is_offline_until);
                } else {
                    this.$set(this.integration_ue, 'status', data.status);
                    this.$set(this.integration_ue, 'is_offline_until', data.is_offline_until);
                }

                if(this.modalUE && this.modalUE.id == idLocalMain) {
                    this.$set(this.modalUE, 'status', data.status);
                    this.$set(this.modalUE, 'is_offline_until', data.is_offline_until);
                }
                this.modalStatusUe = null;
                this.Info('Estado actualizado');
            }).catch(err => {
                this.Response(err)
            })
        },
        UpdateBussyModeUE(){
            if (!this.modalUE.set_bussy_mode) this.$set(this.modalUE, 'set_bussy_mode', {});

            this.$set(this.modalUE.set_bussy_mode, 'delay_duration', this.modalSetBussyMode.delay_duration);
            this.$set(this.modalUE.set_bussy_mode, 'delay_until', this.modalSetBussyMode.delay_until);
            this.modalSetBussyMode = null;
        },
        ModalEditZone(zone, index){
            if(!zone) return;
            if(zone.label == '') zone.label = `Zona ${index == 0 ? 1 : (index+1)}`;
            this.modalZone = Util.Copy(zone, {edit: index, old_label: zone.label});
        },
        //TODO: corregir el nombre de esta funcion, deberia se algo como OpenModalEditRule
        ModaLEditRule(rule, index) {
            if(!rule) return;
            if(rule.label == '') rule.label = `Regla ${index == 0 ? 1 : (index+1)}`;
            this.modalRule = Util.Copy(rule, {delivery_zones: rule.delivery_zones, edit: index})
        },
        OpenModalHideMethodsGhostClose() {
            let copy = Util.Copy(this.hideMethodsGhostClose);
            this.modalHideMethodsGhostClose = copy;
        },
        SaveHideMethodsGhostClose() {
            this.hideMethodsGhostClose = this.modalHideMethodsGhostClose;
            this.modalHideMethodsGhostClose = null;
        },
        OpenModalNewBrand() {
            this.modalNewBrand = { name : ''};
        },
        CreateBrand() {
            if(!this.modalNewBrand.name) return this.Info("Debe ingresar un nombre para la marca");
            this.Loading();
            axios.put(`/local/${this.Local.id}/brand`, this.modalNewBrand).then(res => {
                this.modalNewBrand = null;
                this.brands = [...this.brands, res.data];
                this.Response(res.data);
            }).catch(err => {
                this.Response(err);
            });
        },
        UpdateBrand(brand) {
            if(!brand.name) return this.Info("Debe ingresar un nombre para la marca");
            let index = this.brands.findIndex(b => b.id == brand.id);
            this.Loading();
            axios.patch(`/local/brand/${brand.id}`, brand).then(res => {
                this.$set(this.brands, index, res.data);
                this.modalProfile = null;
                this.Response(res.data);
            }).catch(err => {
                this.Response(err);
            });
        },
        DeleteBrand(brand){
            let index = this.brands.findIndex(b => b.id == brand.id);
            // Al eliminar esta marca, considerar como afecta en las demas opciones donde estaría. Pedidos ya, pedidos online, menu virtual, platafdorma, etc
            this.Loading();
            axios.delete(`/local/brand/${brand.id}`).then(res => {
                this.brands.splice(index, 1);
                this.Response(res.data);
            }).catch(err => {
                this.Response(err);
            });
            
        },
        SaveSchedule() {
            var moment = require('moment');
            const isTimestampDate = this.isTimestampDate(this.modalSchedule.day);

            //verificar horas de horario
            var start = this.Util.TimeToMinutes(this.modalSchedule.start);
            var finish = this.Util.TimeToMinutes(this.modalSchedule.finish);

            if(start >= finish){
                if (this.modalSchedule.day == 'WEEK') {
                    this.Util.DaysArr.forEach(day => {
                        const currentIndex = this.dictDays.indexOf(day);
                        const nextDay = this.dictDays[(currentIndex + 1) % 7];
                        this.modalUE.schedule.push({
                            day: day,
                            start: this.modalSchedule.start,
                            finish: '23:59',
                            delivery: true,
                            takeaway: true
                        });
                        this.modalUE.schedule.push({
                            day: nextDay,
                            start: '00:00',
                            finish: this.modalSchedule.finish,
                            delivery: true,
                            takeaway: true
                        });
                    });
                    this.modalSchedule = null;
                    return this.SortSchedules();
                }

                const currentIndex = this.dictDays.indexOf(this.modalSchedule.day);
                const nextDayIndex = (currentIndex + 1) % 7;
                const nextDay = this.dictDays[nextDayIndex];

                let schedule1 = this.Util.Copy(this.modalSchedule);
                let schedule2 = this.Util.Copy(this.modalSchedule);

                schedule1.finish = '23:59';

                schedule2.day = nextDay;
                schedule2.start = '00:00';
                delete schedule2.index;
                
                if('index' in schedule1){
                    var index = schedule1.index;
                    delete schedule1.index;
                    this.$set(this.modalUE.schedule, index, schedule1);
                }else{
                    this.modalUE.schedule.push(schedule1);
                }
                
                this.modalUE.schedule.push(schedule2);
                this.modalSchedule = null;
                return this.SortSchedules();
            }

            if('index' in this.modalSchedule)
            {
                var index = this.modalSchedule.index;
                delete this.modalSchedule.index;
                this.$set(this.modalUE.schedule, index, this.modalSchedule);
            }
            else
            {
                if(this.modalSchedule.day == 'WEEK')
                {
                    this.Util.DaysArr.forEach(day => {
                        this.modalUE.schedule.push({
                            day: day,
                            start: this.modalSchedule.start,
                            finish: this.modalSchedule.finish,
                            delivery: true,
                            takeaway: true
                        });
                    });
                }
                else
                {
                    this.modalUE.schedule.push(this.modalSchedule);
                }
            }
            this.modalSchedule = null;
            this.SortSchedules();
        },
        isTimestampDate(day) {
            // valida si es timestamp unix o dia de la semana
            if(typeof day === 'number' && day > 0) {
                return true;
            }
            const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday', 'week'];
            return !weekDays.includes(day && day.toLowerCase());
        },
        SortSchedules() 
        {
            var daysVal = {
                monday: 0,
                tuesday: 100000,
                wednesday: 200000,
                thursday: 300000,
                friday: 400000,
                saturday: 500000,
                sunday: 600000
            };

            this.modalUE.schedule.sort((a, b) => {
                var valA = daysVal[a.day] + this.Util.TimeToMinutes(a.start);
                var valB = daysVal[b.day] + this.Util.TimeToMinutes(b.start);
                return valA - valB;
            });
        },
        OpenConfigTerminals() {
            this.Loading();
            axios.get(`/settings/${this.Local.id}/mercadopago/terminals`).then((res) => {
                let data = res.data.data;
                if(!data.terminals.length) return this.Info("No hay terminales registradas");
                this.modalTerminal = data.terminals;
                this.Response(res);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        SaveTerminalConfig() {
            this.Loading();
            axios.post(`/settings/${this.Local.id}/mercadopago/terminals`, {terminals : this.modalTerminal}).then(({data}) => {
                this.modalTerminal = null;
                this.Response(data);
                this.Info("Configuración de terminales guardada correctamente");
            })
            .catch( err => {
                this.Response(err);
            });
        },
        SaveGoogleMapsApi() {
            this.Loading();
            var Axios = require('axios');
            Axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=chile&key=${this.modalGoogleMapsApi.key}`).then(({data}) => {
                if(data && data.status == "OK")
                {
                    this.Info("Llave API de Google Maps ingresada correctamente");
                    this.config.google_maps_api_key = this.modalGoogleMapsApi.key;
                    this.modalGoogleMapsApi = null;
                }
                else
                {
                    this.Info("La llave API de Google Maps ingresada no es válida");
                    this.$set(this.modalGoogleMapsApi, 'error', data);
                }
            })
            .catch( err => {
                this.Response(err);
            });
        },
    },
    computed: {
        transbankPaymentMethods() {
            let ret = [{text: 'Transbank',  value: 'Transbank'}];
            this.config.payment_methods.forEach(method => {
                ret.push({text: method.title,  value: method.title});
            });
            return ret;
        },
        LoadZoneDelivery() {
            if(!this.modalRule || !this.delivery) return;
            return this.delivery.zones.filter(zone => zone && zone.label && zone.label.trim() !== '').map(zone => ({ text: zone.label, description: '', value: zone.label }))
        }
    }
}
</script>

<style>
.logo-image {
    height: 100px;
}
.logo-image img {
    height: 100%;
}
.local-gradient {
    background: linear-gradient(to bottom, rgb(0, 181, 255) 0%,white 15%);
}
</style>
